<template>
    <section id="price-list-internal" class="container">
        <div class="sidebar_left">
            <div class="content_header_container">
                <h1 class="content_header_title">Прайс - лист</h1>
                <div class="download_btn" @click.stop="openAttributesDialog()" v-if="isMobile()">
                    <span v-if="isDownloadPriceList">Зачекайте..</span>
                        <svg v-else width="16" height="18" viewBox="0 0 16 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M12 10H9V0H7V10H4L8 14L12 10ZM0 16V18H16V16H0Z" fill="#356EEF"/>
                    </svg>
                </div>
            </div>

            <div class="mobile_bar" v-if="isMobile()">
                <div class="mobile_bar_items">
                    <div class="open_catalog_popup" @click.stop="modal_categories=!modal_categories">
                        <svg width="20" height="13" viewBox="0 0 20 13" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M0 10.5V12.5H20V10.5H0ZM0 5.5V7.5H20V5.5H0ZM0 0.5V2.5H20V0.5H0Z" fill="#356EEF"/>
                        </svg>
                    </div>
                    <div class="open_filters_popup" @click.stop="modal_filter=!modal_filter">
                        <svg width="17" height="16" viewBox="0 0 17 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M7.625 15.75V10.5H9.375V12.25H16.375V14H9.375V15.75H7.625ZM0.625 14V12.25H5.875V14H0.625ZM4.125 10.5V8.75H0.625V7H4.125V5.25H5.875V10.5H4.125ZM7.625 8.75V7H16.375V8.75H7.625ZM11.125 5.25V0H12.875V1.75H16.375V3.5H12.875V5.25H11.125ZM0.625 3.5V1.75H9.375V3.5H0.625Z" fill="#356EEF"/>
                        </svg>
                        <div class="red_dot" v-if="filters.length || selectedBrands.length || selectedCaharacteristics.length"></div>
                    </div>
                </div>
                <div class="mobile_bar_items">
                    <div class="open_sorting_popup" @click.stop="modal_sorting=!modal_sorting">
                        <svg width="15" height="19" viewBox="0 0 15 19" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M4 10.375V4.09687L1.74687 6.35L0.5 5.125L4.875 0.75L9.25 5.125L8.00312 6.35L5.75 4.09687V10.375H4ZM10.125 18.25L5.75 13.875L6.99687 12.65L9.25 14.9031V8.625H11V14.9031L13.2531 12.65L14.5 13.875L10.125 18.25Z" fill="#356EEF"/>
                        </svg>
                        <div class="red_dot" v-if="sortByDialog"></div>
                    </div>
                    <div class="open_search_popup" @click.stop="modal_search=!modal_search">
                        <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M12.5 11H11.71L11.43 10.73C12.41 9.59 13 8.11 13 6.5C13 2.91 10.09 0 6.5 0C2.91 0 0 2.91 0 6.5C0 10.09 2.91 13 6.5 13C8.11 13 9.59 12.41 10.73 11.43L11 11.71V12.5L16 17.49L17.49 16L12.5 11ZM6.5 11C4.01 11 2 8.99 2 6.5C2 4.01 4.01 2 6.5 2C8.99 2 11 4.01 11 6.5C11 8.99 8.99 11 6.5 11Z" fill="#356EEF"/>
                        </svg>
                        <div class="red_dot" v-if="searchval"></div>
                    </div>
                </div>
            </div>

            <div class="search_input_block" v-if="modal_search">
                <input class="catalog_search_input" v-on:keyup="searchEvent()" v-model="searchval" placeholder="Пошук" />
                
                <svg v-if="!searchval" width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M12.5 11H11.71L11.43 10.73C12.41 9.59 13 8.11 13 6.5C13 2.91 10.09 0 6.5 0C2.91 0 0 2.91 0 6.5C0 10.09 2.91 13 6.5 13C8.11 13 9.59 12.41 10.73 11.43L11 11.71V12.5L16 17.49L17.49 16L12.5 11ZM6.5 11C4.01 11 2 8.99 2 6.5C2 4.01 4.01 2 6.5 2C8.99 2 11 4.01 11 6.5C11 8.99 8.99 11 6.5 11Z" fill="#356EEF"/>
                </svg>

                <svg class="close_modal" v-if="searchval" @click="clearSearchEvent()" width="14" height="17" viewBox="0 0 14 17" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M14 2.26151L12.59 0.709961L7 6.86112L1.41 0.709961L0 2.26151L5.59 8.41266L0 14.5638L1.41 16.1154L7 9.96421L12.59 16.1154L14 14.5638L8.41 8.41266L14 2.26151Z" fill="#356EEF"/>
                </svg>
            </div>

            <div class="filters" v-if="!isMobile()">
                <div class="filters_tabs">
                    <div class="filters_tab_variant" :class="{active: activeTab === 1}" @click="activeTab=1">Каталог товарів</div>
                    <div v-if="!selectedProduct" class="filters_tab_variant" :class="{active: activeTab === 2}"  @click="activeTab=2">
                        Фільтри
                    </div>
                </div>
                <div class="filter_content" v-if="activeTab === 1">
                    <template v-if="catalog.length">
                        <nested-list
                            :list="catalog"
                            :expanded-items="expandedCategories"
                            :selected-items="selectedCatalogs"
                        >
                            <template #item="{node, level}">
                                <nested-item
                                    :id="node.remote_id"
                                    :title="node.label"
                                    :childs="node.children"
                                    :expanded="expandedCategories.includes(node.remote_id)"
                                    :selected="checkSelected(node)"
                                    :level="level"
                                    :type="node.type"
                                    @selectcategory="filterSelectCategory"
                                    @expand="expandCategory"
                                >
                                </nested-item>
                            </template>
                        </nested-list>
                    </template>
                    <span v-else>Зачекайте..</span>
                    <!-- <Tree v-if="catalog.length" v-model:selectionKeys="selectedCatalogs" :value="catalog" selectionMode="single" class="catalog_tree"></Tree> -->
                </div>
                <div class="filter_content" v-if="activeTab === 2">
                    <div class="filter_content_top">
                        <a v-if="filters.length || selectedBrands.length || selectedCaharacteristics.length" class="text-danger p-button-clear" href="javascript:void(0)" @click="clearFilters()">Скинути всі <i class="pi pi-times p-button-danger"></i></a>
                    </div>
                    <div class="tab_container">
                        <div class="tab">
                            <div class="tab_head hovered" @click="activateTab(1)" :class="{active: activeTabs.includes(1)}">
                                <p class="tab_head_title m-0">Загальні</p>
                                <svg :class="{is_expanded: activeTabs.includes(1)}" width="12" height="8" viewBox="0 0 12 8" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M10.59 0.0898437L6 4.66984L1.41 0.0898437L0 1.49984L6 7.49984L12 1.49984L10.59 0.0898437Z" fill="#356EEF"/>
                                </svg>
                            </div>
                            <div class="tab_content" v-if="activeTabs.includes(1)">
                                <div class="flex items-center mb-2 mt-2 pl-1">
                                    <Checkbox v-model="filters" @change="selectDesctopFilterEvent()" :value="'only_price'" name="category" />
                                    <label class="pl-2 tree-item">Тільки із ціною</label>
                                </div>
                                <div class="flex items-center mb-2 mt-2 pl-1">
                                    <Checkbox v-model="filters" @change="selectDesctopFilterEvent()" :value="'only_in_stock'" name="category" />
                                    <label class="pl-2 tree-item">Тільки в наявності</label>
                                </div>
                                <div class="flex items-center mb-2 mt-2 pl-1" v-if="settings && settings.is_promo_view">
                                    <Checkbox v-model="filters" @change="selectDesctopFilterEvent()" :value="'is_promo'" name="category" />
                                    <label class="pl-2 tree-item">Акція</label>
                                </div>
                                <div class="flex items-center mb-2 mt-2 pl-1" v-if="settings && settings.is_new_view">
                                    <Checkbox v-model="filters" @change="selectDesctopFilterEvent()" :value="'is_new'" name="category" />
                                    <label class="pl-2 tree-item">Новинка</label>
                                </div>
                                <div class="flex items-center mb-2 mt-2 pl-1" v-if="settings && settings.is_hit_view">
                                    <Checkbox v-model="filters" @change="selectDesctopFilterEvent()" :value="'is_hit'" name="category" />
                                    <label class="pl-2 tree-item">Хіт</label>
                                </div>
                            </div>
                        </div>
                        <div class="tab" v-if="settings && settings.brand_view">
                            <div class="tab_head hovered" @click="activateTab(2)">
                                <p class="tab_head_title m-0">Бренди</p>
                                <svg :class="{is_expanded: activeTabs.includes(2)}" width="12" height="8" viewBox="0 0 12 8" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M10.59 0.0898437L6 4.66984L1.41 0.0898437L0 1.49984L6 7.49984L12 1.49984L10.59 0.0898437Z" fill="#356EEF"/>
                                </svg>
                            </div>
                            <div class="tab_content" v-if="activeTabs.includes(2)">
                                <template v-if="brands.length && !loadBrands">
                                    <div v-for="brand of brands" :key="brand.key" class="flex items-center mb-2 mt-2 pl-1">
                                        <Checkbox v-model="selectedBrands" @change="selectBrandEvent()" :inputId="brand.key" name="category" :value="brand.key" />
                                        <label :for="brand.key" class="pl-2 tree-item">{{ brand.label }} ({{ brand.products_count }})</label>
                                    </div>
                                </template>
                                <span v-else-if="loadBrands" class="text_secondary">Зачекайте..</span>
                                <span v-else-if="!brands.length && !loadBrands" class="text_secondary">Немає результатів</span>
                            </div>
                        </div>
                        <div class="tab" v-for="(caharacteristicGroup, key) in caharacteristicsFilter" :key="key">
                            <div class="tab_head hovered" @click="activateTab(key)">
                                <p class="tab_head_title m-0">{{key}}</p>
                                <svg :class="{is_expanded: activeTabs.includes(key)}" width="12" height="8" viewBox="0 0 12 8" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M10.59 0.0898437L6 4.66984L1.41 0.0898437L0 1.49984L6 7.49984L12 1.49984L10.59 0.0898437Z" fill="#356EEF"/>
                                </svg>
                            </div>
                            <div class="tab_content" v-if="activeTabs.includes(key)">
                                <div v-for="caharacteristic of caharacteristicGroup" :key="caharacteristic.id" class="flex items-center mb-2 mt-2 pl-1">
                                    <Checkbox v-model="selectedCaharacteristics" @change="selectCaharacteristicEvent()" :inputId="caharacteristic.id" name="category" :value="caharacteristic" />
                                    <label :for="caharacteristic.id" class="pl-2 tree-item">{{ caharacteristic.value }} {{ caharacteristic.product_count ? '('+ caharacteristic.product_count +')' : '' }}</label>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="main_content" v-if="isMobile()">
            <div class="content_result">
                <div class="toggle_header active">
                    <label class="form_label">
                        <template v-for="(item, key) in path" :key="key">
                            <a href="javascript:void(0)" @click.stop="filterSelectCategory({id: item.id, type: item.type})" class="path_item">{{ item.name }}</a> <span> / </span>
                        </template>
                    </label>

                    <svg v-if="selectedProduct" @click.stop="() => {selectedProduct=null; deleteParam(['product']); getProducts() }" width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M14 1.41L12.59 0L7 5.59L1.41 0L0 1.41L5.59 7L0 12.59L1.41 14L7 8.41L12.59 14L14 12.59L8.41 7L14 1.41Z" fill="#356EEF"/>
                    </svg>
                </div>

                <template v-if="!selectedProduct">
                    <div class="product_list_container" :class="{loading_back: loading}">
                        <span class="data-loader" v-if="loading">
                            <div class="lds-ring"><div></div><div></div><div></div><div></div></div>
                        </span>
                        <template v-else>
                            <div class="product_list_item" v-for="(item, key) in data" :key="key" @click.stop="getProduct(item.remote_id)">
                                <div class="product_list_item_top">
                                    <div class="mobile_image_container">
                                        <img :src="item.image ? item.image : '/img/no_image.png'" width="70" class="product_list_item_image" />
                                    </div>
                                    <div class="item_right_content">
                                        <p class="product_list_item_name">
                                            {{ item.name }}
                                            <Tag class="promo_tag_list_mobile" severity="danger" value="%" v-if="settings && settings.is_promo_view && item.is_promo"></Tag>
                                            <Tag class="promo_tag_list_mobile" severity="success" value="NEW" v-if="settings && settings.is_new_view && item.is_new"></Tag>
                                            <Tag class="promo_tag_list_mobile" severity="warning" style="color: #FFFFFF;" value="HIT" v-if="settings && settings.is_hit_view && item.is_hit"></Tag>
                                        </p>
                                        <div class="item_additional_info">
                                            <p class="product_list_item_sku">{{ item.article }}</p>
                                            <p class="product_list_item_quantity"><span :class="{in_stock: item.balance === 'в наявності', out_of_stock: item.balance === 'очікується'}">{{ item.balance }}</span></p>
                                        </div>
                                        <div class="product_list_item_bottom">
                                            <p class="product_list_item_price">
                                                <span>{{ item.price ? number_format(item.price, 2, ',', ' ') + ' грн.' : 'за запитом' }}</span>
                                                <!-- <span class="text_secondary">{{ item.price_in_currency ? number_format(item.price_in_currency, 2, ',', ' ') : '' }} {{ item.catalog_currency ? item.catalog_currency.clear_name : '' }}</span> -->
                                            </p>
                                            <p class="product_list_item_detail">Деталі</p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </template>

                        <Paginator
                            :rows="perPage"
                            :totalRecords="total"
                            :rowsPerPageOptions="[10]"
                            template="CurrentPageReport FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink"
                            currentPageReportTemplate="Товарів {totalRecords}"
                            :pageLinkSize="3"
                            @page="onPage($event)"
                        ></Paginator>
                    </div>
                </template>

                <template v-else>
                    <div class="product_info_container">
                        <div class="block_main_info">
                            <p class="product_title"><b>{{ selectedProduct.name }}</b></p>
                            <div class="product_info_images">
                                <div class="promo_tag_list">
                                    <Tag class="promo_tag_item" severity="danger" value="АКЦІЯ" v-if="settings && settings.is_promo_view && selectedProduct.is_promo"></Tag>
                                    <Tag class="promo_tag_item" severity="success" value="НОВИНКА" v-if="settings && settings.is_new_view && selectedProduct.is_new"></Tag>
                                    <Tag class="promo_tag_item" severity="warning" style="color: #FFFFFF;" value="ХІТ" v-if="settings && settings.is_hit_view && selectedProduct.is_hit"></Tag>
                                </div>

                                <Carousel :value="selectedProductMediaFiles" :numVisible="1" :numScroll="1" containerClass="#product_images_carousel" v-if="selectedProductMediaFiles.length">
                                    <template #item="slotProps">
                                        <!-- <iframe v-if="slotProps.data.type === '360'" type="text/html"
                                                class="product_media_modal_main_img"
                                                :src="slotProps.data.url"
                                                frameborder="0"/> -->
                                        <img :src="slotProps.data.url" class="product_main_img" />
                                    </template>
                                </Carousel>
                                <img v-else :src="'/img/no_image.png'" class="product_main_img" />
                            </div>
                            <template v-if="selectedProduct">
                            <p class="product_info_text">Артикул: {{ selectedProduct.article }}</p>
                            <p class="product_info_text">Ціна: {{ selectedProduct.price ? number_format(selectedProduct.price, 2, ',', ' ') + ' грн. з ПДВ' : 'за запитом' }}</p>
                            <p class="product_info_text">Наявність: <span :class="{in_stock: selectedProduct.balance === 'в наявності', out_of_stock: selectedProduct.balance === 'очікується'}">{{ selectedProduct.balance }}</span></p>
                            <p v-if="settings && settings.brand_view" class="product_info_text">Бренд: {{ selectedProduct.brand ? selectedProduct.brand.title : '-' }}</p>
                            </template>
                        </div>
                        <div class="tabs">
                            <div class="tabs_row">
                                <div v-if="settings && settings.description_view" class="tab_item" :class="{ active: is_drop_4 }" v-on:click="()=> {is_drop_1=false; is_drop_2=false; is_drop_3=false;is_drop_4=true;is_drop_5=false;is_drop_6=false;is_drop_7=false;}">Опис</div>
                                <div v-if="settings && settings.characteristics_view" class="tab_item" :class="{ active: is_drop_1 }" v-on:click="()=> {is_drop_1=true; is_drop_2=false; is_drop_3=false;is_drop_4=false;is_drop_5=false;is_drop_6=false;is_drop_7=false;}">Характеристики</div>
                                <div v-if="settings && settings.accessories_view" class="tab_item" :class="{ active: is_drop_2 }" v-on:click="()=> {is_drop_1=false; is_drop_2=true; is_drop_3=false;is_drop_4=false;is_drop_5=false;is_drop_6=false;is_drop_7=false;}">Аксесуари</div>
                                <div v-if="settings && settings.analogs_view" class="tab_item" :class="{ active: is_drop_5 }" v-on:click="()=> {is_drop_1=false; is_drop_2=false; is_drop_3=false;is_drop_4=false;is_drop_5=true;is_drop_6=false;is_drop_7=false;}">Аналог</div>
                                <div v-if="settings && settings.buy_with_product_view" class="tab_item" :class="{ active: is_drop_6 }" v-on:click="()=> {is_drop_1=false; is_drop_2=false; is_drop_3=false;is_drop_4=false;is_drop_5=false;is_drop_6=true;is_drop_7=false;}">З цим товаром купують</div>
                                <div v-if="settings && settings.decision_view" class="tab_item" :class="{ active: is_drop_7 }" v-on:click="()=> {is_drop_1=false; is_drop_2=false; is_drop_3=false;is_drop_4=false;is_drop_5=false;is_drop_6=false;is_drop_7=true}">Рішення</div>
                                <div v-if="settings && settings.documentation_view" class="tab_item" :class="{ active: is_drop_3 }" v-on:click="()=> {is_drop_1=false; is_drop_2=false; is_drop_3=true;is_drop_4=false;is_drop_5=false;is_drop_6=false;is_drop_7=false; reselectFileAllTreeItem()}">Документація</div>
                            </div>
                        </div>
                        <div class="block_info">
                            <div class="info_list">
                                <template v-if="is_drop_4">
                                    <div class="info_list_content description_content">
                                        <div v-html="selectedProductDescription" v-if="selectedProductDescription"></div>
                                    </div>
                                </template>

                                <template v-if="is_drop_1">
                                    <div class="info_list_content">
                                        <template v-for="(feature, key) in selectedProductFeatures" :key="key">
                                            <div class="info_list_item" v-if="feature.value && feature.value !== ''">
                                                <p class="info_list_item_title">{{ feature.title }}:</p>
                                                <p class="info_list_item_value">{{ feature.value }} {{ feature.unit && feature.unit !== '-' ? feature.unit : '' }}</p>
                                            </div>
                                        </template>
                                    </div>
                                </template>

                                <template v-if="is_drop_2">
                                    <div class="info_list_content table_container">
                                        <template v-if="isAccesoriesGrouped">
                                            <template v-for="(items, type) in selectedProductAccesories" :key="type">
                                                <p style="font-weight: 700;padding: 12px;margin: 0px;">{{ type }}:</p>
                                                <div class="product_list_item" v-for="(item, key) in items" :key="key" @click.stop="getProduct(item.remote_id)">
                                                    <div class="product_list_item_top">
                                                        <div class="mobile_image_container">
                                                            <img :src="item.image ? item.image : '/img/no_image.png'" width="70" class="product_list_item_image" />
                                                        </div>
                                                        <div class="item_right_content">
                                                            <p class="product_list_item_name">{{ item.name }}</p>
                                                            <div class="item_additional_info">
                                                                <p class="product_list_item_sku">{{ item.article }}</p>
                                                                <p class="product_list_item_quantity"><span :class="{in_stock: item.balance === 'в наявності', out_of_stock: item.balance === 'очікується'}">{{ item.balance }}</span></p>
                                                            </div>
                                                            <div class="product_list_item_bottom">
                                                                <p class="product_list_item_price">
                                                                    <span>{{ item.price ? number_format(item.price, 2, ',', ' ') + ' грн.' : 'за запитом' }}</span>
                                                                    <!-- <span class="text_secondary">{{ item.price_in_currency ? number_format(item.price_in_currency, 2, ',', ' ') : '' }} {{ item.catalog_currency ? item.catalog_currency.clear_name : '' }}</span> -->
                                                                </p>
                                                                <p class="product_list_item_detail">Деталі</p>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </template>
                                        </template>
                                        <template v-else>
                                            <template v-for="(items, type) in selectedProductAccesories" :key="type">
                                                <div class="product_list_item" v-for="(item, key) in items" :key="key" @click.stop="getProduct(item.remote_id)">
                                                    <div class="product_list_item_top">
                                                        <div class="mobile_image_container">
                                                            <img :src="item.image ? item.image : '/img/no_image.png'" width="70" class="product_list_item_image" />
                                                        </div>
                                                        <div class="item_right_content">
                                                            <p class="product_list_item_name">{{ item.name }}</p>
                                                            <div class="item_additional_info">
                                                                <p class="product_list_item_sku">{{ item.article }}</p>
                                                                <p class="product_list_item_quantity"><span :class="{in_stock: item.balance === 'в наявності', out_of_stock: item.balance === 'очікується'}">{{ item.balance }}</span></p>
                                                            </div>
                                                            <div class="product_list_item_bottom">
                                                                <p class="product_list_item_price">
                                                                    <span>{{ item.price ? number_format(item.price, 2, ',', ' ') + ' грн.' : 'за запитом' }}</span>
                                                                    <!-- <span class="text_secondary">{{ item.price_in_currency ? number_format(item.price_in_currency, 2, ',', ' ') : '' }} {{ item.catalog_currency ? item.catalog_currency.clear_name : '' }}</span> -->
                                                                </p>
                                                                <p class="product_list_item_detail">Деталі</p>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </template>
                                        </template>
                                    </div>
                                </template>

                                <template v-if="is_drop_5">
                                    <div class="info_list_content table_container">
                                        <div class="product_list_item" v-for="(item, key) in analogs" :key="key" @click.stop="getProduct(item.remote_id)">
                                            <div class="product_list_item_top">
                                                <div class="mobile_image_container">
                                                    <img :src="item.image ? item.image : '/img/no_image.png'" width="70" class="product_list_item_image" />
                                                </div>
                                                <div class="item_right_content">
                                                    <p class="product_list_item_name">{{ item.name }}</p>
                                                    <div class="item_additional_info">
                                                        <p class="product_list_item_sku">{{ item.article }}</p>
                                                        <p class="product_list_item_quantity"><span :class="{in_stock: item.balance === 'в наявності', out_of_stock: item.balance === 'очікується'}">{{ item.balance }}</span></p>
                                                    </div>
                                                    <div class="product_list_item_bottom">
                                                        <p class="product_list_item_price">
                                                            <span>{{ item.price ? number_format(item.price, 2, ',', ' ') + ' грн.' : 'за запитом' }}</span>
                                                            <!-- <span class="text_secondary">{{ item.price_in_currency ? number_format(item.price_in_currency, 2, ',', ' ') : '' }} {{ item.catalog_currency ? item.catalog_currency.clear_name : '' }}</span> -->
                                                        </p>
                                                        <p class="product_list_item_detail">Деталі</p>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </template>

                                <template v-if="is_drop_6">
                                    <div class="info_list_content table_container">
                                        <div class="product_list_item" v-for="(item, key) in buy_with_products" :key="key" @click.stop="getProduct(item.remote_id)">
                                            <div class="product_list_item_top">
                                                <div class="mobile_image_container">
                                                    <img :src="item.image ? item.image : '/img/no_image.png'" width="70" class="product_list_item_image" />
                                                </div>
                                                <div class="item_right_content">
                                                    <p class="product_list_item_name">{{ item.name }}</p>
                                                    <div class="item_additional_info">
                                                        <p class="product_list_item_sku">{{ item.article }}</p>
                                                        <p class="product_list_item_quantity"><span :class="{in_stock: item.balance === 'в наявності', out_of_stock: item.balance === 'очікується'}">{{ item.balance }}</span></p>
                                                    </div>
                                                    <div class="product_list_item_bottom">
                                                        <p class="product_list_item_price">
                                                            <span>{{ item.price ? number_format(item.price, 2, ',', ' ') + ' грн.' : 'за запитом' }}</span>
                                                            <!-- <span class="text_secondary">{{ item.price_in_currency ? number_format(item.price_in_currency, 2, ',', ' ') : '' }} {{ item.catalog_currency ? item.catalog_currency.clear_name : '' }}</span> -->
                                                        </p>
                                                        <p class="product_list_item_detail">Деталі</p>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </template>

                               <template v-if="is_drop_7">
                                    <div class="info_list_content table_container">
                                        <table class="item_table">
                                            <tr class="table_head">
                                                <th style="width: 50%;">Найменування рішення</th>
                                                <th style="width: 50%;">Типи клієнтів</th>
                                            </tr>
                                            <tr v-for="(decision, key) in decisions" :key="key">
                                                <th>{{ decision.name }}</th>
                                                <th>
                                                    <div class="flex_list">
                                                        <p style="margin: 0px;" v-for="(client_type, key) in decision.client_types" :key="key">{{ client_type.name }}</p>
                                                    </div>
                                                </th>
                                            </tr>
                                        </table>
                                    </div>
                                </template>
                                    
                                <template v-if="is_drop_3">
                                    <div class="modal_content files_modal files_tab_content">
                                        <div class="modal_files_contetn_container">
                                            <div class="checkbox_tree">
                                                <div class="checkbox_tree_item" v-for="(media, key) in selectedProductFiles" :key="key">
                                                    <div class="checkbox_tree_header">
                                                        <svg v-on:click="expandFileTree(key)" :class="{'expanded' : expandedTreeItems.includes(key)}" width="13" height="8" viewBox="0 0 13 8" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                            <path d="M1.91 7.91016L6.5 3.33016L11.09 7.91016L12.5 6.50016L6.5 0.500156L0.5 6.50016L1.91 7.91016Z" fill="#356EEF"/>
                                                        </svg>
                                                        <label class="form_label">
                                                            <input value="1" type="checkbox" :indeterminate.prop="preCheckedFiles.includes(key)" :checked="selectedTreeItems.includes(key)" class="form_radio" v-on:change="selectFileAllTreeItem(key)">
                                                            <span class="selected_value"><b>{{ key }}</b></span>
                                                        </label>
                                                    </div>

                                                    <div class="checkbox_tree_body" v-if="!expandedTreeItems.includes(key)">
                                                        <div class="form_label" v-for="(file, i) in media" :key="i">
                                                            <input :value="file.ext" type="checkbox" :checked="selectedTreeItems.includes(key+'|'+i)" class="form_radio" v-on:change="selectFileTreeItem(key, i)">
                                                            <a :href="file.file" target="_blank" class="selected_value file_link">{{ file.name }}</a>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="modal_content_footer">
                                            <span class="modal_content_footer_subtitle">Кількість файлів - {{ filesCount() }} шт. ({{ formatBytes(totalFilesSize) }})</span>
                                            <a href="javascript:void(0)" class="modal_content_footer_btn" v-on:click="downloadFiles()" v-if="!fileownloading && filesCount() > 0">
                                                Завантажити
                                            </a>
                                            <a href="javascript:void(0)" class="modal_content_footer_btn disabled" v-else-if="filesCount() === 0">
                                                Завантажити
                                            </a>
                                            <a href="javascript:void(0)" class="modal_content_footer_btn" v-else>
                                                Завантаження..
                                            </a>
                                        </div>
                                    </div>
                                </template>
                            </div>
                        </div>
                    </div>
                </template>
            </div>
        </div>
        <div class="main_content" v-if="!isMobile()">
            <div class="main_content__head">
                <div class="search_input_block">
                    <input class="catalog_search_input" v-on:keyup="searchEvent()" v-model="searchval" placeholder="Пошук" />
                    
                    <svg v-if="!searchval" width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M12.5 11H11.71L11.43 10.73C12.41 9.59 13 8.11 13 6.5C13 2.91 10.09 0 6.5 0C2.91 0 0 2.91 0 6.5C0 10.09 2.91 13 6.5 13C8.11 13 9.59 12.41 10.73 11.43L11 11.71V12.5L16 17.49L17.49 16L12.5 11ZM6.5 11C4.01 11 2 8.99 2 6.5C2 4.01 4.01 2 6.5 2C8.99 2 11 4.01 11 6.5C11 8.99 8.99 11 6.5 11Z" fill="#356EEF"/>
                    </svg>

                    <svg class="close_modal" v-if="searchval" @click="clearSearchEvent()" width="14" height="17" viewBox="0 0 14 17" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M14 2.26151L12.59 0.709961L7 6.86112L1.41 0.709961L0 2.26151L5.59 8.41266L0 14.5638L1.41 16.1154L7 9.96421L12.59 16.1154L14 14.5638L8.41 8.41266L14 2.26151Z" fill="#356EEF"/>
                    </svg>
                </div>
                <div class="download_btn" @click.stop="openAttributesDialog()">
                    <svg width="16" height="18" viewBox="0 0 16 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M12 10H9V0H7V10H4L8 14L12 10ZM0 16V18H16V16H0Z" fill="#356EEF"/>
                    </svg>
                    <span v-if="isDownloadPriceList">Зачекайте..</span>
                    <span v-else>Завантажити</span>
                </div>
            </div>

            <div class="content_result">
                <div class="toggle_header active">
                    <label class="form_label">
                        <template v-for="(item, key) in path" :key="key">
                            <a href="javascript:void(0)" @click.stop="filterSelectCategory({id: item.id, type: item.type})" class="path_item">{{ item.name }}</a> <span> / </span>
                        </template>
                    </label>

                    <svg v-if="selectedProduct" @click.stop="() => {selectedProduct=null; deleteParam(['product']); getProducts() }" width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M14 1.41L12.59 0L7 5.59L1.41 0L0 1.41L5.59 7L0 12.59L1.41 14L7 8.41L12.59 14L14 12.59L8.41 7L14 1.41Z" fill="#356EEF"/>
                    </svg>
                </div>

                <!-- <h4 v-if="selectedProduct" class="product_title">{{ selectedProduct.name }}</h4> -->

                <template v-if="!selectedProduct">
                    <DataTable
                        :value="data"
                        v-model:selection="selectedProduct"
                        selectionMode="single"
                        :metaKeySelection="true"
                        paginator
                        lazy
                        :rows="perPage"
                        :rowsPerPageOptions="[10]"
                        :total-records="total"
                        :loading="loading"
                        :first="first"
                        @page="onPage($event)"
                        @filter="getData()"
                        class="price_list_categories_table"
                        @sort="onSort($event)"
                        @rowSelect="getProduct()"
                        scrollable
                        scrollHeight="62vh"
                        paginatorTemplate="CurrentPageReport FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink"
                        currentPageReportTemplate="Товарів {totalRecords}"
                    >
                        <Column field="id" header="Фото" style="flex: 0 0 7%; justify-content: center;">
                            <template #body="slotProps">
                                <div class="list_img_container">
                                    <div class="promo_tag_list">
                                        <Tag class="promo_tag_list_tag" severity="danger" value="%" v-if="settings && settings.is_promo_view && slotProps.data.is_promo"></Tag>
                                        <Tag class="promo_tag_list_tag" severity="success" value="NEW" v-if="settings && settings.is_new_view && slotProps.data.is_new"></Tag>
                                        <Tag class="promo_tag_list_tag" severity="warning" style="color: #FFFFFF;" value="HIT" v-if="settings && settings.is_hit_view && slotProps.data.is_hit"></Tag>
                                    </div>
                                    <img :src="slotProps.data.image ? slotProps.data.image : '/img/no_image.png'" class="product_list_img" />
                                </div>
                            </template>
                        </Column>
                        <Column field="article" :sortable="true" header="Артикул" style="flex: 0 0 15%;">
                            <template #body="slotProps">
                                {{ slotProps.data.article }}
                            </template>
                        </Column>
                        <Column field="name" :sortable="true" header="Найменування" style="flex: 0 0 53%;">
                            <template #body="slotProps">
                                {{ slotProps.data.name }}
                            </template>
                        </Column>
                        <Column field="price" :sortable="true" style="justify-content: flex-end; flex: 0 0 12%;">
                            <template #header>
                                Ціна грн. <br> з ПДВ
                            </template>
                            <template #body="slotProps">
                                <div class="p_prices">
                                    <span>{{ slotProps.data.price ? number_format(slotProps.data.price, 2, ',', ' ') : 'за запитом' }}</span>
                                    <span class="text_secondary">{{ slotProps.data.price_in_currency ? number_format(slotProps.data.price_in_currency, 2, ',', ' ') : '' }} {{ slotProps.data.catalog_currency ? slotProps.data.catalog_currency.clear_name : '' }}</span>
                                </div>
                            </template>
                        </Column>
                        <Column field="balance" :sortable="true" header="Наявність" style="justify-content: flex-end; text-align: end; flex: 0 0 13%;">
                            <template #body="slotProps">
                                <span :class="{in_stock: slotProps.data.balance === 'в наявності', out_of_stock: slotProps.data.balance === 'очікується'}">{{ slotProps.data.balance }}</span>
                            </template>
                        </Column>
                    </DataTable>
                </template>

                <template v-else>
                    <div class="tabs">
                        <div class="tabs_row">
                            <div class="tabs_row_item">
                                <div v-if="settings && settings.description_view" class="tab_item" :class="{ active: is_drop_4 }" v-on:click="()=> {is_drop_1=false; is_drop_2=false; is_drop_3=false;is_drop_4=true;is_drop_5=false;is_drop_6=false;is_drop_7=false;}">Опис</div>
                                <div v-if="settings && settings.characteristics_view" class="tab_item" :class="{ active: is_drop_1 }" v-on:click="()=> {is_drop_1=true; is_drop_2=false; is_drop_3=false;is_drop_4=false;is_drop_5=false;is_drop_6=false;is_drop_7=false;}">Характеристики</div>
                            </div>
                            <div class="tabs_row_item">
                                <div v-if="settings && settings.accessories_view" class="tab_item" :class="{ active: is_drop_2 }" v-on:click="()=> {is_drop_1=false; is_drop_2=true; is_drop_3=false;is_drop_4=false;is_drop_5=false;is_drop_6=false;is_drop_7=false;}">Аксесуари</div>

                                <div v-if="settings && settings.analogs_view" class="tab_item" :class="{ active: is_drop_5 }" v-on:click="()=> {is_drop_1=false; is_drop_2=false; is_drop_3=false;is_drop_4=false;is_drop_5=true;is_drop_6=false;is_drop_7=false;}">Аналог</div>
                                <div v-if="settings && settings.buy_with_product_view" class="tab_item" :class="{ active: is_drop_6 }" v-on:click="()=> {is_drop_1=false; is_drop_2=false; is_drop_3=false;is_drop_4=false;is_drop_5=false;is_drop_6=true;is_drop_7=false;}">З цим товаром купують</div>
                                <div v-if="settings && settings.decision_view" class="tab_item" :class="{ active: is_drop_7 }" v-on:click="()=> {is_drop_1=false; is_drop_2=false; is_drop_3=false;is_drop_4=false;is_drop_5=false;is_drop_6=false;is_drop_7=true;}">Рішення</div>

                                <div v-if="settings && settings.documentation_view" class="tab_item" :class="{ active: is_drop_3 }" v-on:click="()=> {is_drop_1=false; is_drop_2=false; is_drop_3=true;is_drop_4=false;is_drop_5=false;is_drop_6=false;is_drop_7=false; reselectFileAllTreeItem()}">Документація</div>
                            </div>
                        </div>
                    </div>
                    <div class="product_info_container">
                        <div class="block_main_info">
                            <div class="block_images">
                                <div class="main_img_container" @click="opensSliderModalAction()">
                                    <div class="promo_tag_list">
                                        <Tag class="promo_tag_item" severity="danger" value="АКЦІЯ" v-if="settings && settings.is_promo_view && selectedProduct.is_promo"></Tag>
                                        <Tag class="promo_tag_item" severity="success" value="НОВИНКА" v-if="settings && settings.is_new_view && selectedProduct.is_new"></Tag>
                                        <Tag class="promo_tag_item" severity="warning" style="color: #FFFFFF;" value="ХІТ" v-if="settings && settings.is_hit_view && selectedProduct.is_hit"></Tag>
                                    </div>

                                    <template v-if="selectedProductMediaFiles.length && selectedProductMediaFiles[selectedMediaIndex].type === 'photo'">
                                        <img :src="selectedProductMediaFiles[selectedMediaIndex].url" class="product_main_img"/>
                                    </template>
                                    <template v-else-if="selectedProductMediaFiles.length && selectedProductMediaFiles[selectedMediaIndex].type === 'video'">
                                        <iframe type="text/html"
                                            class="product_main_img product_video_iframe"
                                            style="width: 100%!important;"
                                            :src="selectedProductMediaFiles[selectedMediaIndex].url"
                                            frameborder="0"/>
                                    </template>
                                    <!-- <template v-else-if="selectedProductMediaFiles.length && selectedProductMediaFiles[selectedMediaIndex].type === '360'">
                                        <iframe type="text/html"
                                            class="product_media_modal_main_img"
                                            :src="selectedProductMediaFiles[selectedMediaIndex].url"
                                            frameborder="0"/>
                                    </template> -->
                                    <img v-else src="/img/no_image.png" class="product_main_img"/>

                                    <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <g clip-path="url(#clip0_4264_534856)">
                                        <rect width="18" height="18" rx="1" fill="white" fill-opacity="0.6"/>
                                        <path d="M14.25 9.75H9.75V14.25H8.25V9.75H3.75V8.25H8.25V3.75H9.75V8.25H14.25V9.75Z" fill="#356EEF"/>
                                        </g>
                                        <defs>
                                        <clipPath id="clip0_4264_534856">
                                        <rect width="18" height="18" rx="1" fill="white"/>
                                        </clipPath>
                                        </defs>
                                    </svg>
                                </div>
                                <div id="modalSubItems" class="sub_images" v-if="selectedProductMediaFiles.length">
                                    <template v-for="(media, key) in selectedProductMediaFiles" :key="key">
                                        <div class="sub_image_box" v-if="media.type === 'photo'" :class="{'active': selectedMediaIndex == key}" @click="selectedMediaIndex = key">
                                            <img :src="media.url" class="product_img" />
                                        </div>

                                        <!-- <iframe v-else type="text/html"
                                            :src="media.url"
                                            frameborder="0"/> -->
                                         <!-- <div class="sub_image_box" v-else-if="media.type === '360'" :class="{'active': selectedMediaIndex == key}" @click="selectedMediaIndex = key">
                                            <img src="/img/360.png" class="product_img" />
                                         </div> -->
                                         <div class="sub_image_box" v-else :class="{'active': selectedMediaIndex == key}" @click="selectedMediaIndex = key">
                                            <img src="/img/video.png" class="product_img" />
                                         </div>
                                    </template>
                                </div>
                                <div class="sub_images" v-else>
                                    <img src="/img/no_image.png" class="product_img"/>
                                    <img src="/img/no_image.png" class="product_img"/>
                                    <img src="/img/no_image.png" class="product_img"/>
                                </div>
                            </div>
                            <template v-if="selectedProduct">
                            <p class="product_title"><b>{{ selectedProduct.name }}</b></p>
                            <p class="product_info_text">Артикул: {{ selectedProduct.article }}</p>
                            <p class="product_info_text">Ціна: {{ selectedProduct.price ? number_format(selectedProduct.price, 2, ',', ' ') + ' грн. з ПДВ' : 'за запитом' }}</p>
                            <p class="product_info_text">Наявність: <span :class="{in_stock: selectedProduct.balance === 'в наявності', out_of_stock: selectedProduct.balance === 'очікується'}">{{ selectedProduct.balance }}</span></p>
                            <p v-if="settings && settings.brand_view" class="product_info_text">Бренд: {{ selectedProduct.brand ? selectedProduct.brand.title : '-' }}</p>
                            </template>
                        </div>
                        <div class="block_info">
                            <div class="info_list">
                                <template v-if="is_drop_4">
                                    <div class="info_list_content description_content">
                                        <div v-html="selectedProductDescription" v-if="selectedProductDescription"></div>
                                    </div>
                                </template>

                                <template v-if="is_drop_1">
                                    <div class="info_list_content">
                                        <template v-for="(feature, key) in selectedProductFeatures" :key="key">
                                            <div class="info_list_item" v-if="feature.value && feature.value !== ''">
                                                <p class="info_list_item_title">{{ feature.title }}:</p>
                                                <p class="info_list_item_value">{{ feature.value }} {{ feature.unit && feature.unit !== '-' ? feature.unit : '' }}</p>
                                            </div>
                                        </template>
                                    </div>
                                </template>

                                <template v-if="is_drop_2">
                                    <div class="info_list_content table_container">
                                        <table class="item_table">
                                            <tr class="table_head">
                                                <th style="width: 15%;">Артикул</th>
                                                <th style="width: 60%;">Найменування</th>
                                                <th style="width: 15%;">Ціна грн. з ПДВ</th>
                                                <th style="width: 10%;">Наявність</th>
                                            </tr>
                                            <template v-if="isAccesoriesGrouped">
                                                <template v-for="(items, type) in selectedProductAccesories" :key="type">
                                                    <tr>
                                                        <td colspan="4" style="font-weight: 700;">
                                                            {{ type }}:
                                                        </td>
                                                    </tr>
                                                    <tr v-for="(accesory, key) in items" :key="key">
                                                        <th>{{ accesory.article }}</th>
                                                        <th><a href="javascript:void(0)" @click.stop="() => {selectedProduct = accesory; getProduct()}">{{ accesory.name }}</a></th>
                                                        <th>{{ accesory.price ? number_format(accesory.price, 2, ',', ' ') : 'за запитом' }}</th>
                                                        <th><span :class="{in_stock: accesory.balance === 'в наявності', out_of_stock: accesory.balance === 'очікується'}">{{ accesory.balance }}</span></th>
                                                    </tr>
                                                </template>
                                            </template>
                                            <template v-else>
                                                <template v-for="(items, type) in selectedProductAccesories" :key="type">
                                                    <tr v-for="(accesory, key) in items" :key="key">
                                                        <th>{{ accesory.article }}</th>
                                                        <th><a href="javascript:void(0)" @click.stop="() => {selectedProduct = accesory; getProduct()}">{{ accesory.name }}</a></th>
                                                        <th>{{ accesory.price ? number_format(accesory.price, 2, ',', ' ') + ' грн.' : 'за запитом' }}</th>
                                                        <th><span :class="{in_stock: accesory.balance === 'в наявності', out_of_stock: accesory.balance === 'очікується'}">{{ accesory.balance }}</span></th>
                                                    </tr>
                                                </template>
                                            </template>
                                        </table>
                                    </div>
                                </template>

                                <template v-if="is_drop_5">
                                    <div class="info_list_content table_container">
                                        <table class="item_table">
                                            <tr class="table_head">
                                                <th style="width: 15%;">Артикул</th>
                                                <th style="width: 60%;">Найменування</th>
                                                <th style="width: 15%;">Ціна грн. з ПДВ</th>
                                                <th style="width: 10%;">Наявність</th>
                                            </tr>
                                            <tr v-for="(accesory, key) in analogs" :key="key">
                                                <th>{{ accesory.article }}</th>
                                                <th><a href="javascript:void(0)" @click.stop="() => {selectedProduct = accesory; getProduct()}">{{ accesory.name }}</a></th>
                                                <th>{{ accesory.price ? number_format(accesory.price, 2, ',', ' ') + ' грн.' : 'за запитом' }}</th>
                                                <th><span :class="{in_stock: accesory.balance === 'в наявності', out_of_stock: accesory.balance === 'очікується'}">{{ accesory.balance }}</span></th>
                                            </tr>
                                        </table>
                                    </div>
                                </template>

                                <template v-if="is_drop_6">
                                    <div class="info_list_content table_container">
                                        <table class="item_table">
                                            <tr class="table_head">
                                                <th style="width: 15%;">Артикул</th>
                                                <th style="width: 60%;">Найменування</th>
                                                <th style="width: 15%;">Ціна грн. з ПДВ</th>
                                                <th style="width: 10%;">Наявність</th>
                                            </tr>
                                            <tr v-for="(accesory, key) in buy_with_products" :key="key">
                                                <th>{{ accesory.article }}</th>
                                                <th><a href="javascript:void(0)" @click.stop="() => {selectedProduct = accesory; getProduct()}">{{ accesory.name }}</a></th>
                                                <th>{{ accesory.price ? number_format(accesory.price, 2, ',', ' ') + ' грн.' : 'за запитом' }}</th>
                                                <th><span :class="{in_stock: accesory.balance === 'в наявності', out_of_stock: accesory.balance === 'очікується'}">{{ accesory.balance }}</span></th>
                                            </tr>
                                        </table>
                                    </div>
                                </template>

                                <template v-if="is_drop_7">
                                    <div class="info_list_content table_container">
                                        <table class="item_table">
                                            <tr class="table_head">
                                                <th style="width: 50%;">Найменування рішення</th>
                                                <th style="width: 50%;">Типи клієнтів</th>
                                            </tr>
                                            <tr v-for="(decision, key) in decisions" :key="key">
                                                <th>{{ decision.name }}</th>
                                                <th>
                                                    <div class="flex_list">
                                                        <p style="margin: 0px;" v-for="(client_type, key) in decision.client_types" :key="key">{{ client_type.name }}</p>
                                                    </div>
                                                </th>
                                            </tr>
                                        </table>
                                    </div>
                                </template>
                                    
                                <template v-if="is_drop_3">
                                    <div class="modal_content files_modal files_tab_content">
                                        <div class="modal_files_contetn_container">
                                            <div class="checkbox_tree">
                                                <div class="checkbox_tree_item" v-for="(media, key) in selectedProductFiles" :key="key">
                                                    <div class="checkbox_tree_header">
                                                        <svg v-on:click="expandFileTree(key)" :class="{'expanded' : expandedTreeItems.includes(key)}" width="13" height="8" viewBox="0 0 13 8" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                            <path d="M1.91 7.91016L6.5 3.33016L11.09 7.91016L12.5 6.50016L6.5 0.500156L0.5 6.50016L1.91 7.91016Z" fill="#356EEF"/>
                                                        </svg>
                                                        <label class="form_label">
                                                            <input value="1" type="checkbox" :indeterminate.prop="preCheckedFiles.includes(key)" :checked="selectedTreeItems.includes(key)" class="form_radio" v-on:change="selectFileAllTreeItem(key)">
                                                            <span class="selected_value"><b>{{ key }}</b></span>
                                                        </label>
                                                    </div>

                                                    <div class="checkbox_tree_body" v-if="!expandedTreeItems.includes(key)">
                                                        <div class="form_label" v-for="(file, i) in media" :key="i">
                                                            <input :value="file.ext" type="checkbox" :checked="selectedTreeItems.includes(key+'|'+i)" class="form_radio" v-on:change="selectFileTreeItem(key, i)">
                                                            <a :href="file.file" target="_blank" class="selected_value file_link">{{ file.name }}</a>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="modal_content_footer">
                                            <span class="modal_content_footer_subtitle">Кількість файлів - {{ filesCount() }} шт. ({{ formatBytes(totalFilesSize) }})</span>
                                            <a href="javascript:void(0)" class="modal_content_footer_btn" v-on:click="downloadFiles()" v-if="!fileownloading && filesCount() > 0">
                                                Завантажити
                                            </a>
                                            <a href="javascript:void(0)" class="modal_content_footer_btn disabled" v-else-if="filesCount() === 0">
                                                Завантажити
                                            </a>
                                            <a href="javascript:void(0)" class="modal_content_footer_btn" v-else>
                                                Завантаження..
                                            </a>
                                        </div>
                                    </div>

                                    <!-- <div class="info_list_content">

                                        <div class="row_file" v-for="(media, key) in selectedProductFiles" :key="key">
                                            <span class="modal_file_name">{{ key }}</span>
                                            <span class="underline"></span>
                                            <div class="docs_row" :class="{grid: Object.keys(media).length > 3}">
                                                <a v-for="(file, i) in media" :key="i" :href="file.file" target="_blank" class="modal_file_link">
                                                    <svg width="16" height="20" viewBox="0 0 16 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                    <path d="M2 0C0.9 0 0.0100002 0.9 0.0100002 2L0 18C0 19.1 0.89 20 1.99 20H14C15.1 20 16 19.1 16 18V6L10 0H2ZM9 7V1.5L14.5 7H9Z" fill="#356EEF"/>
                                                    </svg>
                                                    {{ file.ext }}
                                                </a>
                                            </div>
                                        </div>
                                    </div>

                                    <a href="javascript:void(0)" class="download_all_btn" v-if="Object.entries(selectedProductFiles).length" v-on:click="modal_files = true">
                                        <svg width="14" height="17" viewBox="0 0 14 17" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <path d="M14 6H10V0H4V6H0L7 13L14 6ZM0 15V17H14V15H0Z" fill="#356EEF"/>
                                        </svg>
                                        Скачати все
                                    </a> -->
                                </template>
                            </div>
                        </div>
                    </div>
                </template>
            </div>
        </div>

        <Dialog v-model:visible="opensSliderModal" id="accessory-products-modal" header="" :style="{ width: '500px' }" modal :contentStyle="{ height: 'auto' }">
            <div class="modal_content">
                <div class="product_media_modal_main_img_container">
                    <template v-if="selectedProductMediaFiles.length && selectedProductMediaFiles[selectedMediaIndex].type === 'photo'">
                        <img :src="selectedProductMediaFiles[selectedMediaIndex].url" class="product_media_modal_main_img"/>
                    </template>
                    <template v-else-if="selectedProductMediaFiles.length && selectedProductMediaFiles[selectedMediaIndex].type === 'video'">
                        <iframe type="text/html"
                            class="product_media_modal_main_img"
                            :src="selectedProductMediaFiles[selectedMediaIndex].url"
                            frameborder="0"/>
                    </template>
                    <!-- <template v-else-if="selectedProductMediaFiles.length && selectedProductMediaFiles[selectedMediaIndex].type === '360'">
                        <iframe type="text/html"
                            class="product_media_modal_main_img"
                            :src="selectedProductMediaFiles[selectedMediaIndex].url"
                            frameborder="0"/>
                    </template> -->
                    <img v-else src="/img/no_image.png" class="product_media_modal_main_img"/>

                    <div class="group_btns">
                        <a href="javascript:void(0)" @click="()=> {selectedMediaIndex > 0 ? selectedMediaIndex-- : selectedMediaIndex}">
                            <svg width="8" height="12" viewBox="0 0 8 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M7.91016 1.41L3.33016 6L7.91016 10.59L6.50016 12L0.500156 6L6.50016 0L7.91016 1.41Z" fill="#356EEF"/>
                            </svg>
                        </a>
                        <a href="javascript:void(0)" @click="modalNextMedia()">
                            <svg width="8" height="12" viewBox="0 0 8 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M0.0898437 1.41L4.66984 6L0.0898437 10.59L1.49984 12L7.49984 6L1.49984 0L0.0898437 1.41Z" fill="#356EEF"/>
                            </svg>
                        </a>
                    </div>
                </div>

                <div class="product_media_modal_sub_images" v-if="selectedProductMediaFiles.length">
                    <template v-for="(media, key) in selectedProductMediaFiles" :key="key">
                        <div class="prev_img_box" v-if="media.type === 'photo'" @click="selectedMediaIndex = key" :class="{'active': selectedMediaIndex == key}">
                            <img :src="media.url" class="product_media_modal_img" />
                        </div>
                        <!-- <div class="prev_img_box" v-else-if="media.type === '360'" :class="{'active': selectedMediaIndex == key}" @click="selectedMediaIndex = key">
                            <img src="/img/360.png" class="product_media_modal_img" />
                        </div> -->
                        <div class="prev_img_box" v-else @click="selectedMediaIndex = key" :class="{'active': selectedMediaIndex == key}">
                            <img src="/img/video.png" class="product_media_modal_img" />
                        </div>
                    </template>
                </div>
                <div class="product_media_modal_sub_images" v-else>
                    <div class="prev_img_box">
                        <img src="/img/no_image.png" class="product_media_modal_img"/>
                    </div>
                    <div class="prev_img_box">
                        <img src="/img/no_image.png" class="product_media_modal_img"/>
                    </div>
                    <div class="prev_img_box">
                        <img src="/img/no_image.png" class="product_media_modal_img"/>
                    </div>
                </div>
            </div>
        </Dialog>

        <Dialog v-model:visible="modal_files" id="files_dialog" header="Обрати файли для завантажування" :style="{ width: '330px' }" modal :contentStyle="{ height: 'auto' }">
            <div class="modal_content files_modal">
                <div class="modal_files_contetn_container">
                    <label class="toggle">
                        <input class="toggle__checkbox" type="checkbox" v-model="isSelectFileAllTreeItem" v-on:change="selectFileAllTreeItem(key)">
                        <span class="toggle__switch"></span>
                        <span class="title">Усі</span>
                    </label>

                    <div class="checkbox_tree">
                        <div class="checkbox_tree_item" v-for="(media, key) in selectedProductFiles" :key="key">
                            <div class="checkbox_tree_header">
                                <label class="form_label">
                                    <input value="1" type="checkbox" :indeterminate.prop="preCheckedFiles.includes(key)" :checked="selectedTreeItems.includes(key)" class="form_radio" v-on:change="selectFileAllTreeItem(key)">
                                    <span class="selected_value"><b>{{ key }}</b></span>
                                </label>
                                <svg v-on:click="expandFileTree(key)" :class="{'expanded' : expandedTreeItems.includes(key)}" width="13" height="8" viewBox="0 0 13 8" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M1.91 7.91016L6.5 3.33016L11.09 7.91016L12.5 6.50016L6.5 0.500156L0.5 6.50016L1.91 7.91016Z" fill="#356EEF"/>
                                </svg>
                            </div>

                            <div class="checkbox_tree_body" v-if="expandedTreeItems.includes(key)">
                                <label class="form_label" v-for="(file, i) in media" :key="i">
                                    <input :value="file.ext" type="checkbox" :checked="selectedTreeItems.includes(key+'|'+i)" class="form_radio" v-on:change="selectFileTreeItem(key, i)">
                                    <span class="selected_value">{{ file.ext }}</span>
                                </label>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="modal_content_footer">
                    <span class="modal_content_footer_subtitle">Кількість файлів - {{ filesCount() }} шт. ({{ formatBytes(totalFilesSize) }})</span>
                    <a href="javascript:void(0)" class="modal_content_footer_btn" v-on:click="downloadFiles()" v-if="!fileownloading && filesCount() > 0">
                        Завантажити
                    </a>
                    <a href="javascript:void(0)" class="modal_content_footer_btn disabled" v-else-if="filesCount() === 0">
                        Завантажити
                    </a>
                    <a href="javascript:void(0)" class="modal_content_footer_btn" v-else>
                        Завантаження..
                    </a>
                </div>
            </div>
        </Dialog>

        <Dialog v-model:visible="modal_attrbibutes" id="attributes_dialog" header="Обрати атрибути для завантаження" :style="{ width: '400px' }" :breakpoints="{ '760px': '90vw' }" modal :contentStyle="{ height: 'auto' }">
            <div class="modal_content files_modal">
                <div class="tab_content">
                    <div class="input_row">
                        <Checkbox v-model="checkedAllAttributes" @change="selectAllAttributesTab()" binary />
                        <label>
                            <span>Обрати всі атрибути</span>
                        </label>
                    </div>
                    <Tree v-model:selectionKeys="selectedAttributes" :value="attributes" selectionMode="checkbox" class="catalog_tree"></Tree>
                </div>
                <div class="modal_content_footer">
                    <span class="modal_content_footer_subtitle">Буде завантажено {{ total }} товарів</span>
                    <a href="javascript:void(0)" class="modal_content_footer_btn" v-on:click="downloadExcel()" v-if="!isDownloadPriceList && Object.keys(selectedAttributes).length">
                        Завантажити
                    </a>
                    <a href="javascript:void(0)" class="modal_content_footer_btn disabled" v-else-if="Object.keys(this.selectedAttributes).length === 0">
                        Завантажити
                    </a>
                    <a href="javascript:void(0)" class="modal_content_footer_btn" v-else>
                        Завантаження..
                    </a>
                </div>
            </div>
        </Dialog>

        <Dialog v-model:visible="modal_categories" id="categories_dialog" :header="selectedCategory ? selectedCategory.label : 'Каталог товарів'" :style="{ width: '400px' }" :breakpoints="{ '760px': '100vw' }" modal :contentStyle="{ height: 'auto' }">
            <div class="modal_content categories_modal">
                <template v-if="catalog.length">
                    <template v-if="!selectedCategory">
                        <div class="catalog_list_item" v-for="node in catalog" :key="node.remote_id" :class="{active: filterCategories.includes(node.remote_id)}">
                            <p @click.stop="filterSelectCategory({id: node.remote_id, type: node.type})" class="catalog_list_item_title">{{ node.label }}</p>
                            <span v-if="node.children && node.children.length" @click.stop="categoryNext(node)" class="catalog_list_item_btn">
                                <svg :class="{is_expanded: expanded}" width="8" height="12" viewBox="0 0 8 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M0.0898438 1.41L4.66984 6L0.0898438 10.59L1.49984 12L7.49984 6L1.49984 0L0.0898438 1.41Z" fill="#356EEF"/>
                                </svg>
                            </span>
                        </div>
                    </template>
                    <template v-else>
                        <div class="catalog_list_item_back" @click.stop="categoryBack()">
                            <span class="catalog_list_item_btn">
                                <svg width="8" height="12" viewBox="0 0 8 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M7.91016 1.41L3.33016 6L7.91016 10.59L6.50016 12L0.500156 6L6.50016 0L7.91016 1.41Z" fill="#356EEF"/>
                                </svg>
                            </span>
                            <p class="catalog_list_item_title">{{ selectedCategories.length > 1 && selectedCategories[selectedCategories.length-2] ? selectedCategories[selectedCategories.length-2].label : 'Каталог товарів' }}</p>
                        </div>
                        <div class="catalog_list_item" v-for="node in selectedCategory.children" :key="node.remote_id" :class="{active: filterCategories.includes(node.remote_id)}">
                            <p @click.stop="filterSelectCategory({id: node.remote_id, type: node.type})" class="catalog_list_item_title">{{ node.label }}</p>
                            <span v-if="node.children && node.children.length" @click.stop="categoryNext(node)" class="catalog_list_item_btn">
                                <svg :class="{is_expanded: expanded}" width="8" height="12" viewBox="0 0 8 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M0.0898438 1.41L4.66984 6L0.0898438 10.59L1.49984 12L7.49984 6L1.49984 0L0.0898438 1.41Z" fill="#356EEF"/>
                                </svg>
                            </span>
                        </div>
                    </template>
                </template>
                <span v-else>Зачекайте..</span>
            </div>
        </Dialog>

        <Dialog v-model:visible="modal_filter" id="categories_dialog" header="Фільтри" :style="{ width: '400px' }" :breakpoints="{ '760px': '100vw' }" modal :contentStyle="{ height: '60vh' }">
            <div class="modal_content">
                <div class="tab_container">
                    <div class="tab">
                        <div class="tab_head" @click="activateTab(1)" :class="{active: activeTabs.includes(1)}">
                            <p class="tab_head_title m-0">Загальні</p>
                            <svg :class="{is_expanded: activeTabs.includes(1)}" width="12" height="8" viewBox="0 0 12 8" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M10.59 0.0898437L6 4.66984L1.41 0.0898437L0 1.49984L6 7.49984L12 1.49984L10.59 0.0898437Z" fill="#356EEF"/>
                            </svg>
                        </div>
                        <div class="tab_content" v-if="activeTabs.includes(1)">
                            <div class="flex justify-content-end mb-2 mt-2 pl-1">
                                <span class="clear_filter" v-if="filters.length" @click.stop="() => {filters = []; selectMainFilterEvent()}">
                                    Скинути
                                    <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path d="M14 1.41L12.59 0L7 5.59L1.41 0L0 1.41L5.59 7L0 12.59L1.41 14L7 8.41L12.59 14L14 12.59L8.41 7L14 1.41Z" fill="#356EEF"/>
                                    </svg>
                                </span>
                            </div>
                            <div class="flex items-center mb-2 mt-2 pl-1">
                                <Checkbox v-model="filters" @change="selectMainFilterEvent()" :value="'only_price'" name="category" />
                                <label class="pl-2 tree-item">Тільки із ціною</label>
                            </div>
                            <div class="flex items-center mb-2 mt-2 pl-1">
                                <Checkbox v-model="filters" @change="selectMainFilterEvent()" :value="'only_in_stock'" name="category" />
                                <label class="pl-2 tree-item">Тільки в наявності</label>
                            </div>
                            <div class="flex items-center mb-2 mt-2 pl-1" v-if="settings && settings.is_promo_view">
                                <Checkbox v-model="filters" @change="selectMainFilterEvent()" :value="'is_promo'" name="category" />
                                <label class="pl-2 tree-item">Акція</label>
                            </div>
                            <div class="flex items-center mb-2 mt-2 pl-1" v-if="settings && settings.is_new_view">
                                <Checkbox v-model="filters" @change="selectMainFilterEvent()" :value="'is_new'" name="category" />
                                <label class="pl-2 tree-item">Новинка</label>
                            </div>
                            <div class="flex items-center mb-2 mt-2 pl-1" v-if="settings && settings.is_hit_view">
                                <Checkbox v-model="filters" @change="selectMainFilterEvent()" :value="'is_hit'" name="category" />
                                <label class="pl-2 tree-item">Хіт</label>
                            </div>
                        </div>
                    </div>
                    <div class="tab" v-if="settings && settings.brand_view">
                        <div class="tab_head" @click="activateTab(2)" :class="{active: activeTabs.includes(2)}">
                            <p class="tab_head_title m-0">Бренди</p>
                            <svg :class="{is_expanded: activeTabs.includes(2)}" width="12" height="8" viewBox="0 0 12 8" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M10.59 0.0898437L6 4.66984L1.41 0.0898437L0 1.49984L6 7.49984L12 1.49984L10.59 0.0898437Z" fill="#356EEF"/>
                            </svg>
                        </div>
                        <div class="tab_content" v-if="activeTabs.includes(2)">
                            <div class="flex justify-content-end mb-2 mt-2 pl-1">
                                <span class="clear_filter" v-if="selectedBrands.length" @click.stop="() => {selectedBrands = []; selectDialogBrandEvent()}">
                                    Скинути
                                    <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path d="M14 1.41L12.59 0L7 5.59L1.41 0L0 1.41L5.59 7L0 12.59L1.41 14L7 8.41L12.59 14L14 12.59L8.41 7L14 1.41Z" fill="#356EEF"/>
                                    </svg>
                                </span>
                            </div>
                            <template v-if="brands.length">
                                <div v-for="brand of brands" :key="brand.key" class="flex items-center mb-2 mt-2 pl-1">
                                    <Checkbox v-model="selectedBrands" @change="selectDialogBrandEvent()" :inputId="brand.key" name="category" :value="brand.key" />
                                    <label :for="brand.key" class="pl-2 tree-item">{{ brand.label }} ({{ brand.products_count }})</label>
                                </div>
                            </template>
                            <span v-else>Зачекайте..</span>
                        </div>
                    </div>
                    <div class="tab" v-for="(caharacteristicGroup, key) in caharacteristicsFilter" :key="key">
                        <div class="tab_head" @click="activateTab(key)" :class="{active: activeTabs.includes(key)}">
                            <p class="tab_head_title m-0">{{key}}</p>
                            <svg :class="{is_expanded: activeTabs.includes(key)}" width="12" height="8" viewBox="0 0 12 8" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M10.59 0.0898437L6 4.66984L1.41 0.0898437L0 1.49984L6 7.49984L12 1.49984L10.59 0.0898437Z" fill="#356EEF"/>
                            </svg>
                        </div>
                        <div class="tab_content" v-if="activeTabs.includes(key)">
                            <div class="flex justify-content-end mb-2 mt-2 pl-1">
                                <span class="clear_filter" v-if="selectedCaharacteristics.length" @click.stop="selectedCaharacteristics = []">
                                    Скинути
                                    <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path d="M14 1.41L12.59 0L7 5.59L1.41 0L0 1.41L5.59 7L0 12.59L1.41 14L7 8.41L12.59 14L14 12.59L8.41 7L14 1.41Z" fill="#356EEF"/>
                                    </svg>
                                </span>
                            </div>
                            <div v-for="caharacteristic of caharacteristicGroup" :key="caharacteristic.id" class="flex items-center mb-2 mt-2 pl-1">
                                <Checkbox v-model="selectedCaharacteristics" :inputId="caharacteristic.id" name="category" :value="caharacteristic" />
                                <label :for="caharacteristic.id" class="pl-2 tree-item">{{ caharacteristic.value }} {{ caharacteristic.product_count ? '('+ caharacteristic.product_count +')' : '' }}</label>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <template #footer>
                <div class="modal_btns">
                    <a href="javascript:void(0)" class="remove_all_btn" @click.stop="clearFilterEvent()">Скинути всі</a>
                    <a href="javascript:void(0)" class="add_btn" @click.stop="selectFilterEvent()">Застосувати</a>
                </div>
            </template>
        </Dialog>

        <Dialog v-model:visible="modal_sorting" id="sorting_dialog" header="Сортування" :style="{ width: '400px' }" :breakpoints="{ '760px': '100vw' }" modal :contentStyle="{ height: 'auto' }">
            <div class="modal_content">
                <div class="tab_container">
                    <div class="tab_content">
                        <div class="flex items-center mb-2 mt-2 pl-1">
                            <RadioButton v-model="sortByDialog" @change="() => {sortBy = 'price'; sortOrder = 0;}" :value="'price_up'" name="price_up" />
                            <label class="pl-2 tree-item">За ціною від дешевих</label>
                        </div>
                        <div class="flex items-center mb-2 mt-2 pl-1">
                            <RadioButton v-model="sortByDialog" @change="() => {sortBy = 'price'; sortOrder = 1;}" :value="'price_down'" name="price_down" />
                            <label class="pl-2 tree-item">За ціною від дорогих</label>
                        </div>
                        <div class="flex items-center mb-2 mt-2 pl-1">
                            <RadioButton v-model="sortByDialog" @change="() => {sortBy = 'balance'; sortOrder = 0;}" :value="'balance_up'" name="balance_up" />
                            <label class="pl-2 tree-item">За наявністю від меншої</label>
                        </div>
                        <div class="flex items-center mb-2 mt-2 pl-1">
                            <RadioButton v-model="sortByDialog" @change="() => {sortBy = 'balance'; sortOrder = 1;}" :value="'balance_down'" name="balance_down" />
                            <label class="pl-2 tree-item">За наявністю від більшої</label>
                        </div>
                        <div class="flex items-center mb-2 mt-2 pl-1">
                            <RadioButton v-model="sortByDialog" @change="() => {sortBy = 'name'; sortOrder = 0;}" :value="'name_up'" name="name_up" />
                            <label class="pl-2 tree-item">За назвою А-Я</label>
                        </div>
                        <div class="flex items-center mb-2 mt-2 pl-1">
                            <RadioButton v-model="sortByDialog" @change="() => {sortBy = 'name'; sortOrder = 1;}" :value="'name_down'" name="name_down" />
                            <label class="pl-2 tree-item">За назвою Я-А</label>
                        </div>
                    </div>
                </div>
            </div>
            <template #footer>
                <div class="modal_btns">
                    <a href="javascript:void(0)" class="remove_all_btn" @click.stop="() => {sortByDialog = null; sortBy = null; sortOrder = null; getProducts()}">Скинути</a>
                    <a href="javascript:void(0)" class="add_btn" @click.stop="getProducts()">Застосувати</a>
                </div>
            </template>
        </Dialog>

    </section>
</template>

<script>
import PriceListLayout from "@/Layouts/PriceListLayout";
import axios from "axios";
import Tree from 'primevue/tree';
import NestedList from "./NestedCategories/NestedList.vue";
import NestedItem from "./NestedCategories/NestedItem.vue";
import Checkbox from 'primevue/checkbox';
import RadioButton from 'primevue/radiobutton';
import DataTable from "primevue/datatable";
import Tag from "primevue/tag";
import Column from 'primevue/column';
import Dialog from 'primevue/dialog';
import swal from 'sweetalert2';
import Paginator from 'primevue/paginator';
import Carousel from 'primevue/carousel';

export default {
    layout: PriceListLayout,
    components: {
        Tree,
        NestedList,
        NestedItem,
        Checkbox,
        RadioButton,
        DataTable,
        Column,
        Dialog,
        swal,
        Paginator,
        Carousel,
        Tag,
    },
    props: {
        settings: {
            type: Object,
            required: false,
        },
        attributes: {
            type: Array,
            required: false,
        },
    },
    data() {
        return {
            path: [],

            activeTab: 1,
            
            loading: false,
            isShowCatalog: false,
            isShowBrands: false,
            expandedCategories: [],
            selectedCatalogs: null,
            selectedBrands: [],
            selectedCaharacteristics: [],
            searchedProducts: [],
            searchedProductsCount: 0,
            searchval: null,
            first: 0,
            page: 1,

            catalog: [],
            brands: [],
            loadBrands: false,
            filterCategories: [{id: 0, type: 'product_category'}],

            activeTabs: [1],

            data: [],
            perPage: 10,
            total: 0,
            selectedProduct: null,
            sortByDialog: null,
            sortBy: null,
            sortOrder: null,

            product: null,
            selectedProductMediaFiles: [],
            selectedProductDescription: null,
            selectedProductFeatures: [],
            selectedProductAccesories: [],
            isAccesoriesGrouped: false,
            analogs: [],
            buy_with_products: [],
            decisions: [],
            selectedProductFiles: [],
            totalFilesSize: 0,

            is_drop_1: false,
            is_drop_2: false,
            is_drop_3: false,
            is_drop_4: false,
            is_drop_5: false,
            is_drop_6: false,
            is_drop_7: false,

            selectedMediaIndex: 0,
            opensSliderModal: false,
            isDownloadPriceList: false,

            modal_files: false,
            preCheckedFiles: [],
            expandedTreeItems: [],
            selectedTreeItems: [],
            selectedFiles: {
                '2-D Креслення': [],
                'Інструкція': [],
                'Сертифікат': [],
            },

            selectedTreeItemsOld: [],
            selectedFilesOld: {
                '2-D Креслення': [],
                'Інструкція': [],
                'Сертифікат': [],
            },
            preCheckedFilesOld: [],
            fileownloading: false,

            modal_attrbibutes: false,
            checkedAllAttributes: true,
            selectedAttributes: {},

            caharacteristicsFilter: [],

            modal_search: false,
            modal_categories: false,
            modal_sorting: false,
            modal_filter: false,
            selectedCategory: null,
            selectedCategories: [],
            filters: []
        }
    },
    mounted() {
        window.addEventListener('popstate', this.handleBackNavigation);

        this.getCatalogTree();
        // if (this.settings && this.settings.brand_view) {
            this.getBrandsTree();
        // }
        this.getCaharacteristics();

        // get url get params
        let uri = window.location.search.substring(1); 
        let params = new URLSearchParams(uri);

        if (params.has("product")) {
            this.getProduct(params.get("product"))
        } else {
            this.getProducts();
        }
    },
    beforeDestroy() {
        // Remove the event listeners when the component is destroyed
       window.removeEventListener('popstate', this.handleBackNavigation);
    },
    methods: {
        checkAllSettingsDisabled() {
            if (this.settings) {
                return Object.keys(this.settings).every(key => {
                    // Пропускаем
                    if (key === 'is_promo_view' || key === 'is_new_view' || key === 'is_hit_view' || key === 'custom_brand_view') return true; 
                    return this.settings[key] === false; // Проверяем
                });
            } else {
                return true
            }
        },
        handleBackNavigation(event) {
            // Логика при переходе на предыдущую/следующую страницу

            // get url get params
            let uri = window.location.search.substring(1); 
            let params = new URLSearchParams(uri);

            if (params.has("product")) {
                this.getProduct(params.get("product"))
            }
        },
        insertParam(name, value) {
            // const params = new URLSearchParams(window.location.search);
            // params.set(name, value);
            // window.history.replaceState({}, "", decodeURIComponent(`${window.location.pathname}?${params}`));

            // Get the current URL
            let url = new URL(window.location);

            // Update or insert the parameter
            url.searchParams.set(name, value);

            // Push the updated URL to the browser history without reloading the page
            window.history.pushState({}, '', url);
        },
        deleteParam(names) {
            names.forEach((name, index) => {
                const params = new URLSearchParams(window.location.search);
                params.delete(name);
                window.history.replaceState({}, "", decodeURIComponent(`${window.location.pathname}?${params}`));
            });
        },
        searchEvent() {
            this.page = 1
            this.first = 0
            this.selectedCaharacteristics = []
            this.getProducts();
            this.getCaharacteristics();
        },
        clearSearchEvent() {
            this.page = 1
            this.first = 0
            this.searchval = null
            this.selectedCaharacteristics = []
            this.getProducts();
            this.getCaharacteristics();
        },
        selectBrandEvent() {
            this.page = 1
            this.first = 0
            // this.selectedCaharacteristics = []
            this.getProducts();
            // this.getCaharacteristics();
        },
        selectDialogBrandEvent() {
            this.page = 1
            this.first = 0
            // this.selectedCaharacteristics = []
            // this.getCaharacteristics();
        },
        clearFilters() {
            this.page = 1
            this.first = 0
            this.filters = []
            this.selectedBrands = []
            this.selectedCaharacteristics = []
            this.getBrandsTree();
            this.getProducts();
            this.getCaharacteristics();
        },
        clearFilterEvent() {
            this.modal_filter = !this.modal_filter
            this.page = 1
            this.first = 0
            this.filters = []
            this.selectedBrands = []
            this.selectedCaharacteristics = []
            this.getBrandsTree();
            this.getProducts();
            this.getCaharacteristics();
        },
        selectMainFilterEvent() {
            this.page = 1
            this.first = 0
            // this.selectedBrands = []
            // this.selectedCaharacteristics = []
            this.getBrandsTree();
            // this.getCaharacteristics();
        },
        selectFilterEvent() {
            this.modal_filter = !this.modal_filter
            this.page = 1
            this.first = 0
            this.getProducts();
        },
        selectDesctopFilterEvent() {
            this.page = 1
            this.first = 0
            // this.selectedBrands = []
            // this.selectedCaharacteristics = []
            this.getBrandsTree();
            // this.getCaharacteristics();
            this.getProducts();
        },
        selectCaharacteristicEvent() {
            this.page = 1
            this.first = 0
            this.getBrandsTree();
            this.getProducts();
        },
        openAttributesDialog() {
            this.modal_attrbibutes = !this.modal_attrbibutes

            for (let node of this.attributes) {
                this.selectedAttributes[node.key] = {
                    checked: true,
                    partialChecked: false,
                };
            }
        },
        getCatalogTree() {
            axios.post(this.route('price_list_categories.catalog_tree'), {
                custom_brand_view: this.settings && this.settings.custom_brand_view,
                brand_view: this.settings && this.settings.brand_view,
            }).then((result) => {
                this.catalog = result.data.data
            }).catch((error) => {
                this.uploading = false
                alert(error)
                console.log(error)
                window.scroll(0, 0);
            })
        },
        getBrandsTree() {
            this.loadBrands = true
            if (!this.selectedCaharacteristics.length) {
                this.selectedBrands = []
            }
            axios.post(this.route('price_list_categories.brand_tree'), {
                    category_ids: this.filterCategories,
                    brands: this.selectedBrands,
                    filters: this.filters,
                    caharacteristics: this.selectedCaharacteristics,
                    custom_brand_view: this.settings && this.settings.custom_brand_view,
                    brand_view: this.settings && this.settings.brand_view,
                    type: 1,
                })
                .then((result) => {
                    this.brands = result.data.data

                    if (this.selectedCaharacteristics.length) {
                        this.selectedBrands = this.selectedBrands.filter(
                            (id) => this.brands.some(item2 => item2.key === id)
                        );
                    }

                    this.loadBrands = false
                }).catch((error) => {
                    this.uploading = false
                    alert(error)
                    console.log(error)
                    window.scroll(0, 0);
                    this.loadBrands = false
                })
        },
        getCaharacteristics() {
            this.caharacteristicsFilter = []
            axios.post(this.route('price_list_categories.caharacteristics'), {
                    searchval: this.searchval,
                    categories: this.filterCategories,
                    brands: this.selectedBrands,
                    filters: this.filters,
                    custom_brand_view: this.settings && this.settings.custom_brand_view,
                    brand_view: this.settings && this.settings.brand_view,
                })
                .then((result) => {
                    this.caharacteristicsFilter = result.data.data
                }).catch((error) => {
                    this.uploading = false
                    alert(error)
                    console.log(error)
                    window.scroll(0, 0);
                })
        },
        expandCategory(data) {
            if (this.expandedCategories.includes(data.id))
                this.expandedCategories = this.expandedCategories.filter((id) => id !== data.id)
            else {
                this.expandedCategories.push(data.id)
            }
        },
        activateTab(key) {
            if (this.activeTabs.includes(key))
                this.activeTabs = this.activeTabs.filter((id) => id !== key)
            else {
                this.activeTabs.push(key)
            }
        },
        filterSelectCategory(catId) {
            if (catId) {
                if (this.filterCategories.includes(catId)) {
                    // this.filterCategories = []
                } else {
                    this.filterCategories = []
                    this.filterCategories.push(catId)
                }
            } else {
                this.filterCategories = []
                this.selectedCategory = null
                this.selectedCategories = []
            }

            if (catId === 0) {
                this.filterCategories = [{id: 0, type: 'product_category'}]
            }

            this.modal_categories = false

            this.page = 1
            this.first = 0
            this.searchval = null

            this.selectedCaharacteristics = []

            this.getBrandsTree()

            this.getCaharacteristics()
            
            this.getProducts()
        },
        onPage(event) {
            this.page = event.page+1
            this.getProducts()
        },
        onSort(event) {
            this.page = 1
            this.first = 0
            this.sortBy = event.sortField
            this.sortOrder = event.sortOrder
            this.getProducts()
        },
        getProducts() {
            this.deleteParam(['product'])

            this.loading = true
            this.modal_sorting = false
            this.selectedProduct = null
            this.is_drop_1=false;
            this.is_drop_2=false;
            this.is_drop_3=false;
            this.is_drop_4=false;
            this.is_drop_5=false;
            this.is_drop_6=false;
            this.is_drop_7=false;
            axios.post(this.route('price_list_categories.products'), {
                searchval: this.searchval,
                categories: this.filterCategories,
                brands: this.selectedBrands,
                caharacteristics: this.selectedCaharacteristics,
                filters: this.filters,
                perPage: this.perPage,
                page: this.page,
                sortBy: this.sortBy,
                sortOrder: this.sortOrder,
                custom_brand_view: this.settings && this.settings.custom_brand_view,
                brand_view: this.settings && this.settings.brand_view,
            })
            .then((response) => {
                this.data = response.data.data.data
                this.total = response.data.data.total
                this.path = response.data.path

                this.loading = false
            }).catch((error) => {
                this.loading = false
                console.log(error);
                window.scroll(0, 0);
            })
        },
        getProduct(id) {
            if (this.checkAllSettingsDisabled() === true) {
                this.selectedProduct = null
                return true
            }

            if (id) {
                this.insertParam('product', id)
            } else {
                this.insertParam('product', this.selectedProduct.remote_id)
            }

            this.loading = true
            this.activeTab = 1
            this.selectedMediaIndex = 0
            this.selectedProductMediaFiles = [];
            this.selectedProductDescription = null;
            this.selectedProductFeatures = [];
            this.selectedProductAccesories = [];
            this.analogs = [];
            this.buy_with_products = [];
            this.decisions = [];
            this.selectedProductFiles = [];
            this.totalFilesSize = 0;
            this.is_drop_1=false;
            this.is_drop_2=false;
            this.is_drop_3=false;
            this.is_drop_4=false;
            this.is_drop_5=false;
            this.is_drop_6=false;
            this.is_drop_7=false;
            
            if (this.settings) {
                if (this.settings.description_view) {
                    this.is_drop_4 = true
                } else if (this.settings.characteristics_view) {
                    this.is_drop_1 = true
                } else if (this.settings.accessories_view) {
                    this.is_drop_2 = true
                } else if (this.settings.analogs_view) {
                    this.is_drop_5 = true
                } else if (this.settings.buy_with_product_view) {
                    this.is_drop_6 = true
                } else if (this.settings.decision_view) {
                    this.is_drop_7 = true
                } else if (this.settings.documentation_view) {
                    this.reselectFileAllTreeItem()
                    this.is_drop_3 = true
                }
            }

            axios.get(this.route('price_list_categories.product', {id: id ? id : this.selectedProduct.remote_id}))
            .then((result) => {
                this.selectedProduct = result.data.product;
                this.selectedProductMediaFiles = result.data.mediaFiles;
                this.selectedProductDescription = result.data.description;
                this.selectedProductFeatures = result.data.features;
                this.selectedProductAccesories = result.data.accesories;
                this.isAccesoriesGrouped = result.data.is_accesories_grouped;
                this.analogs = result.data.analogs;
                this.buy_with_products = result.data.buy_with_products;
                this.decisions = result.data.decisions;
                this.selectedProductFiles = result.data.files;
                this.totalFilesSize = result.data.files_size;
                this.path = result.data.path;
                this.expandedCategories = result.data.expandedCategories;
                this.filterCategories = result.data.selectedCategory;

                this.loading = false
            }).catch((error) => {
                this.loading = false
                console.log(error);
                window.scroll(0, 0);
            })
        },

        opensSliderModalAction() {
            this.opensSliderModal = !this.opensSliderModal;
        },

        modalNextMedia() {
            if (this.selectedMediaIndex <= this.selectedProductMediaFiles.length - 2) {
                this.selectedMediaIndex++
            } else {
                this.selectedMediaIndex = 0
            }
            this.$forceUpdate();
        },

        downloadExcel() {
            if (this.isDownloadPriceList) {
                return false
            }

            this.isDownloadPriceList = true
            axios.post(this.route('price_list_categories.export'), {
                searchval: this.searchval,
                categories: this.filterCategories,
                brands: this.selectedBrands,
                caharacteristics: this.selectedCaharacteristics,
                selected_attributes: this.selectedAttributes,
                filters: this.filters,
                custom_brand_view: this.settings && this.settings.custom_brand_view,
                brand_view: this.settings && this.settings.brand_view,
            })
            .then((response) => {
                this.isDownloadPriceList = false
                var fileURL = response.data.data;
                    var fileLink = document.createElement('a');
                    fileLink.href = fileURL;
                    fileLink.setAttribute('download', response.data.name);
                document.body.appendChild(fileLink);
                fileLink.click();
            }).catch((error) => {
                this.isDownloadPriceList = false
                alert(error);
                window.scroll(0, 0);
            })
        },
        filesCount() {
            let count = 0;
            for (const [index, value] of Object.entries(this.selectedFiles)) {
                for (const [i, files] of Object.entries(value)) {
                    count += 1
                }
            }
            return count;
        },
        formatBytes(bytes, decimals = 2) {
            if (!+bytes) return '0 Bytes'

            const k = 1024
            const dm = decimals < 0 ? 0 : decimals
            const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB']

            const i = Math.floor(Math.log(bytes) / Math.log(k))

            return `${parseFloat((bytes / Math.pow(k, i)).toFixed(dm))} ${sizes[i]}`
        },

        downloadFiles() {
            let files = []
            this.fileownloading = true
            for (const [index, value] of Object.entries(this.selectedFiles)) {
                if (Object.keys(value).length) {
                    files.push(value)
                }
            }

            if (files.length) {
                axios.post(this.route('api.vector.download-files'), {
                    files: files,
                }, {
                    responseType: 'blob'
                })
                .then((response) => {
                    const url = window.URL.createObjectURL(new Blob([response.data]));
                    const link = document.createElement("a");
                    link.href = url;
                    link.setAttribute("download", 'Документи_' + this.selectedProduct.article + '_' + this.selectedProduct.name + '.zip');
                    document.body.appendChild(link);
                    link.click();
                    link.remove();
                    this.fileownloading = false
                }).catch((error) => {
                    console.log(error);
                    window.scroll(0, 0);
                })
            } else {
                this.fileownloading = false
            }
        },
        selectFileAllTreeItem (key) {
            if (key) {
                // expand by parent
                if (!this.selectedTreeItems.includes(key)) {
                    this.selectedTreeItems.push(key)
                    let files = this.selectedProductFiles[key];

                    if (!this.selectedFiles[key]) {
                        this.selectedFiles[key] = []
                    }

                    for (const [i, value] of Object.entries(files)) {

                        if (!this.selectedFiles[key].includes(value.file)) {
                            this.selectedFiles[key].push(value.file)
                        }

                        if (!this.selectedTreeItems.includes(key+'|'+i)) {
                            this.selectedTreeItems.push(key+'|'+i)
                        }
                    }
                } else {
                    const index = this.selectedTreeItems.indexOf(key);
                    if (index > -1) {
                        this.selectedTreeItems.splice(index, 1);

                        let files = this.selectedProductFiles[key];
                        for (const [i, value] of Object.entries(files)) {

                            if (this.selectedFiles[key]) {
                                const index = this.selectedFiles[key].indexOf(value.file);
                                if (index > -1) {
                                    this.selectedFiles[key].splice(index, 1);
                                }
                            }

                            const index2 = this.selectedTreeItems.indexOf(key+'|'+i);
                            if (index2 > -1) {
                                this.selectedTreeItems.splice(index2, 1);
                            }
                        }
                    }
                    const index3 = this.preCheckedFiles.indexOf(key);
                    if (index3 > -1) {
                        this.preCheckedFiles.splice(index3, 1);
                    }
                }

                this.selectedTreeItemsOld = _.cloneDeep(this.selectedTreeItems)
                this.selectedFilesOld = _.cloneDeep(this.selectedFiles)
                this.preCheckedFilesOld = _.cloneDeep(this.preCheckedFiles)
            } else {
                if (this.isSelectFileAllTreeItem) {
                    this.selectedTreeItems = [];
                    this.selectedFiles = {
                        '2-D Креслення': [],
                        'Інструкція': [],
                        'Сертифікат': [],
                    };

                    // expand all
                    for (const [index, value] of Object.entries(this.selectedProductFiles)) {
                        if (this.isSelectFileAllTreeItem) {
                            if (!this.selectedTreeItems.includes(index)) {
                                this.selectedTreeItems.push(index)
                            }
                        } else {
                            const mainKey = this.selectedTreeItems.indexOf(index);
                            if (mainKey > -1) {
                                this.selectedTreeItems.splice(mainKey, 1);
                            }
                        }

                        this.selectedFiles[index] = []


                        for (const [childKey, item] of Object.entries(value)) {
                            if (this.isSelectFileAllTreeItem) {
                                if (!this.selectedFiles[index].includes(item.file)) {
                                    this.selectedFiles[index].push(item.file)
                                }

                                if (!this.selectedTreeItems.includes(index+'|'+childKey)) {
                                    this.selectedTreeItems.push(index+'|'+childKey)
                                }
                            } else {
                                const index2 = this.selectedTreeItems.indexOf(index+'|'+childKey);
                                if (index2 > -1) {
                                    this.selectedTreeItems.splice(index2, 1);
                                }
                            }
                        }
                    }
                } else {
                    this.selectedTreeItems = _.cloneDeep(this.selectedTreeItemsOld)
                    this.selectedFiles = _.cloneDeep(this.selectedFilesOld)
                    this.preCheckedFiles = _.cloneDeep(this.preCheckedFilesOld)
                }
            }

            this.reculcSelectedFiles()
        },
        reselectFileAllTreeItem() {
            this.preCheckedFiles = [];
            this.selectedTreeItems = [];
            this.selectedFiles = {
                '2-D Креслення': [],
                'Інструкція': [],
                'Сертифікат': [],
            };

            // expand all
            for (const [index, value] of Object.entries(this.selectedProductFiles)) {
                this.selectedTreeItems.push(index)

                this.selectedFiles[index] = []


                for (const [childKey, item] of Object.entries(value)) {
                    this.selectedFiles[index].push(item.file)
                    this.selectedTreeItems.push(index+'|'+childKey)
                }
            }

            this.reculcSelectedFiles()
        },
        selectFileTreeItem (parent, key) {
            if (!this.selectedTreeItems.includes(parent+'|'+key)) {
                this.selectedTreeItems.push(parent+'|'+key)

                let file = this.selectedProductFiles[parent][key];

                if (!this.selectedFiles[parent]) {
                    this.selectedFiles[parent] = []
                }
                this.selectedFiles[parent].push(file.file)
            } else {
                const index = this.selectedTreeItems.indexOf(parent+'|'+key);
                if (index > -1) {
                    this.selectedTreeItems.splice(index, 1);
                }

                let file = this.selectedProductFiles[parent][key];
                if (this.selectedFiles[parent]) {
                    const index2 = this.selectedFiles[parent].indexOf(file.file);
                    if (index2 > -1) {
                        this.selectedFiles[parent].splice(index2, 1);
                    }
                }
            }

            let total = 0
            for (const [index, value] of Object.entries(this.selectedProductFiles[parent])) {
                total += 1
            }
            let currentTotal = 0
            if (this.selectedFiles[parent]) {
                for (const [index, value] of Object.entries(this.selectedFiles[parent])) {
                    currentTotal += 1
                }
            }

            if (currentTotal < total || currentTotal == total) {
                if (!this.selectedTreeItems.includes(parent)) {
                    this.selectedTreeItems.push(parent)
                }
            }

            if (currentTotal <= 0) {
                if (this.selectedTreeItems.includes(parent)) {
                    const index2 = this.selectedTreeItems.indexOf(parent);
                    if (index2 > -1) {
                        this.selectedTreeItems.splice(index2, 1);
                    }
                }
            }

            if (currentTotal > 0 && currentTotal < total) {
                if (!this.preCheckedFiles.includes(parent)) {
                    this.preCheckedFiles.push(parent)
                }
            } else {
                const index2 = this.preCheckedFiles.indexOf(parent);
                if (index2 > -1) {
                    this.preCheckedFiles.splice(index2, 1);
                }
            }

            this.selectedTreeItemsOld = _.cloneDeep(this.selectedTreeItems)
            this.selectedFilesOld = _.cloneDeep(this.selectedFiles)
            this.preCheckedFilesOld = _.cloneDeep(this.preCheckedFiles)

            console.log(this.selectedFilesOld)

            this.reculcSelectedFiles()
        },
        reculcSelectedFiles() {
            let countTotal = 0;
            let countSelected = 0;
            let selectedFiles = [];

            let totalSize = 0
            for (const [index, value] of Object.entries(this.selectedFiles)) {
                for (const [i, files] of Object.entries(value)) {
                    selectedFiles.push(files)
                    countSelected += 1
                }
            }

            for (const [index, value] of Object.entries(this.selectedProductFiles)) {
                for (const [i, files] of Object.entries(value)) {
                    if (selectedFiles.includes(files.file)) {
                        totalSize += files.size
                    }
                    countTotal += 1
                }
            }

            if (countTotal !== countSelected) {
                this.isSelectFileAllTreeItem = false
            } else {
                this.isSelectFileAllTreeItem = true
                this.preCheckedFiles = []
            }

            this.totalFilesSize = totalSize
        },
        expandFileTree (key) {
            if (!this.expandedTreeItems.includes(key)) {
                this.expandedTreeItems.push(key)
            } else {
                const index = this.expandedTreeItems.indexOf(key);
                if (index > -1) { // only splice array when item is found
                    this.expandedTreeItems.splice(index, 1); // 2nd parameter means remove one item only
                }
            }
        },
        number_format(number, decimals, dec_point, thousands_sep) {
            // Strip all characters but numerical ones.
            number = (number + '').replace(/[^0-9+\-Ee.]/g, '');
            var n = !isFinite(+number) ? 0 : +number,
                prec = !isFinite(+decimals) ? 0 : Math.abs(decimals),
                sep = (typeof thousands_sep === 'undefined') ? ',' : thousands_sep,
                dec = (typeof dec_point === 'undefined') ? '.' : dec_point,
                s = '',
                toFixedFix = function (n, prec) {
                    var k = Math.pow(10, prec);
                    return '' + Math.round(n * k) / k;
                };
            // Fix for IE parseFloat(0.55).toFixed(0) = 0;
            s = (prec ? toFixedFix(n, prec) : '' + Math.round(n)).split('.');
            if (s[0].length > 3) {
                s[0] = s[0].replace(/\B(?=(?:\d{3})+(?!\d))/g, sep);
            }
            if ((s[1] || '').length < prec) {
                s[1] = s[1] || '';
                s[1] += new Array(prec - s[1].length + 1).join('0');
            }
            return s.join(dec);
        },
        selectAllAttributesTab() {
            if (Object.keys(this.selectedAttributes).length === 0) {
                for (let node of this.attributes) {
                    this.selectedAttributes[node.key] = {
                        checked: true,
                        partialChecked: false,
                    };
                }
            } else {
                this.selectedAttributes = {}
            }
        },

        isMobile() {
            return window.innerWidth <= 760;
        },

        categoryNext(category) {
            this.selectedCategory = category
            this.selectedCategories.push(category)
        },

        categoryBack() {
            this.selectedCategories.pop()
            if (this.selectedCategories.length) {
                this.selectedCategory = this.selectedCategories[this.selectedCategories.length - 1]
            } else {
                this.selectedCategory = null
            }
        },

        checkSelected(node) {
            return this.filterCategories.some(item => 
                item.id === node.remote_id && item.type === node.type
            );
        }
    }
}
</script>

<style scoped>
    .in_stock {
        color: green;
    }
    .out_of_stock {
        color: #356eef;
    }
    #price-list-internal {
        display: flex;
        gap: 10px;
        max-width: 2560px;
        margin: 0 auto;
        margin-top: 22px;
        padding-top: 0px;
    }
    .container {
        /* padding: 80px 25px 0 20px; */
    }
    .close_modal {
        cursor: pointer;
    }
    .search_input_block {
        position: relative;
    }
    .content_header_title {
        font-style: normal;
        font-weight: 700;
        font-size: 36px;
        line-height: 43px;
        color: #212529;
        min-width: 330px;
        margin: 0px;
        height: 48px;
    }
    .search_input_block {
        position: relative;
        z-index: 3;
        width: 100%;
    }

    .search_input_block svg {
        position: absolute;
        top: 15px;
        right: 15px;
    }
    .catalog_search_input {
        padding: 6px 16px;
        padding-right: 40px;
        min-width: 461px;
        height: 48px;
        background: #FFFFFF;
        border: 1px solid #C8E4FF;
        border-radius: 4px;
        font-style: normal;
        font-weight: 400;
        font-size: 14px;
        line-height: 21px;
        width: 100%;
    }

    .catalog_search_input:focus {
        outline: none;
    }

    .flex_list {
        display: flex;
        flex-direction: column;
    }

    .download_btn {
        display: flex;
        align-items: center;
        gap: 9px;
        font-style: normal;
        font-weight: 400;
        font-size: 12px;
        line-height: 18px;
        color: #000000;
        height: 48px;
        cursor: pointer;
        padding: 0px 10px;
    }

    .main_content {
        width: 100%;
    }

    .main_content__head {
        display: flex;
        justify-content: space-between;
        gap: 20px;
    }

    .content_result {
        border: 1px solid #C8E4FF;
        border-radius: 4px;
    }

    .content_result, .filters {
        margin-top: 10px;
        height: 75vh;
    }

    .filters {
        border: 1px solid #C8E4FF;
        border-radius: 4px;
        padding: 0 18px;
    }
    .filter_content {
        height: 67vh;
        overflow: auto;
    }
    .filters_tabs {
        display: flex;
        padding: 12px 0px;
        gap: 20px;
        border-bottom: 1px solid #C8E4FF;
    }
    .filters_tab_variant {
        cursor: pointer;
        font-weight: 500;
        padding: 5px;
        color: #212529;
        font-size: 14px;
    }
    .filters_tab_variant.active {
        background-color: #E3F2FF;
        border-radius: 4px;
    }
    .catalog_tree {
        width: 100%;
        border: none;
        padding: 0px;
        color: #000;
        font-size: 16px;
        font-style: normal;
        font-weight: 500;
        line-height: 24px;
        height: 320px;
        overflow: auto;
    }

    .sidebar_left {
        width: 650px;
    }

    .tree-item {
        color: #212529;
        font-size: 14px;
        font-style: normal;
        font-weight: 500;
        line-height: 21px;
    }
    .tab_head_title {
        color: #212529;
        font-size: 14px;
        font-style: normal;
        font-weight: 500;
        line-height: 21px;
    }

    .is_expanded {
        transform: rotate(180deg);
    }

    .tab_head {
        display: flex;
        align-items: center;
        justify-content: space-between;
        padding: 10px .25rem;
        cursor: pointer;
    }

    .tab_head.hovered:hover {
        background-color: #eef7ff;
    }

    .tabs {
        height: 38px;
        border-bottom: 1px solid #C8E4FF;
        display: flex;
        align-items: center;
        justify-content: flex-end;
        padding: 0px 20px;
        gap: 34px;
    }
    .tabs_row {
        display: flex;
        padding: 5px 0px;
    }
    .tabs_row_item {
        display: flex;
        align-items: center;
    }
    .tab_item {
        font-style: normal;
        font-weight: 500;
        font-size: 14px;
        line-height: 21px;
        color: #212529;
        padding: 4px 10px;
        cursor: pointer;
    }
    .tab_item.active {
        background: #E3F2FF;
        border-radius: 4px;
    }
    .product_info_container {
        display: flex;
    }

    .product_info_container .block_main_info .product_info_text:last-child {
        margin-top: 6px;
    }

    .block_main_info {
        display: flex;
        flex-direction: column;
        padding: 20px;
        width: 300px;
    }

    .block_images {
        display: flex;
        gap: 20px;
        padding-top: 6px;
        justify-content: center;
    }

    .sub_images {
        display: flex;
        flex-direction: column;
        gap: 2px;
        max-height: 200px;
        overflow-y: auto;
        overflow-x: hidden;
    }

    .product_media_modal_sub_images {
        width: 100%;
        display: flex;
        gap: 17px;
        overflow: auto;
        padding: 5px 10px 0px 10px;
        margin-bottom: 10px;
    }

    .product_media_modal_sub_images .prev_img_box {
        width: 48px;
        height: 48px;
        display: flex;
        align-items: center;
        justify-content: center;
        cursor: pointer;
    }

    .product_media_modal_sub_images .prev_img_box.active {
        border: 1px solid #C8E4FF;
    }

    #modalSubItems .sub_image_box {
        width: 48px;
        height: 48px;
        display: flex;
        align-items: center;
        justify-content: center;
        cursor: pointer;
    }

    #modalSubItems .sub_image_box.active {
        border: 1px solid #C8E4FF;
    }

    .product_img {
        width: auto;
        height: auto;
        max-width: 47px;
        max-height: 47px;
        cursor: pointer;
    }

    .product_media_modal_img {
        max-width: 47px;
        max-height: 48px;
        height: auto;
        width: auto;
        cursor: pointer;
    }

    .main_img_container {
        position: relative;
        cursor: pointer;
        display: flex;
        justify-content: center;
        width: 180px;
        align-items: center;
    }
    .product_info_images {
        position: relative;
        text-align: center;
    }
    .main_img_container svg {
        position: absolute;
        bottom: 8px;
        right: 8px;
        cursor: pointer;
    }

    .product_info_text {
        margin: 0;
        font-style: normal;
        font-weight: 400;
        font-size: 12px;
        line-height: 18px;
        color: #212529;
        margin-top: 10px;
    }

    .block_info {
        width: 100%;
    }

    .info_list {
        border-left: 1px solid #C8E4FF;
        height: 65vh;
        overflow-x: hidden;
        overflow-y: auto;
        position: relative;
    }

    .info_list_content {
        display: flex;
        flex-direction: column;
        padding: 29px 20px;
        gap: 14px;
        font-size: 12px;
        font-weight: 400;
        line-height: 18px;
        letter-spacing: 0em;
        text-align: left;
    }

    .description_content >>> img {
        max-height: 200px;
        width: auto;
    }

    .info_list_content.table_container {
        padding: 0px;
        gap: 0px;
    }

    .info_list_content .info_list_item {
        display: flex;
        justify-content: space-between;
        align-items: flex-end;
        position: relative;
        -webkit-box-align: start;
        -ms-flex-align: start;
        align-items: flex-start;
        -webkit-align-items: flex-start;
    }

    .docs_row {
        display: flex;
        gap: 20px;
        padding-left: 20px;
    }
    .docs_row.grid {
        display: grid;
        grid-template-columns: repeat(3, 1fr);
        grid-gap: 10px;
        padding-left: 20px;
        align-items: baseline;
    }

    .info_list_item p {
        margin: 0;
        font-style: normal;
        font-weight: 400;
        font-size: 14px;
        line-height: 21px;
        color: #000000;
        background-color: #fff;
        word-break: break-all;
    }

    .info_list_item_value {
        text-align: end;
        min-width: 60px;
    }

    .info_list_item_title {
        text-wrap: nowrap;
    }

    .info_list_item_title::before {
        content: "";
        position: absolute;
        width: 100%;
        left: 0;
        top: 16px;
        height: 1px;
        background-color: #C8E4FF;
        z-index: -1;
    }

    .download_all_btn {
        font-style: normal;
        font-weight: 400;
        font-size: 12px;
        line-height: 18px;
        color: #356EEF;
        align-items: center;
        gap: 11px;
        margin-right: 20px;
        padding-bottom: 20px;
        display: flex;
        justify-content: flex-end;
    }

    .row_file {
        display: flex;
        justify-content: space-between;
        align-items: flex-end;
    }
    .modal_file_name {
        font-style: normal;
        font-weight: 400;
        font-size: 14px;
        line-height: 21px;
        color: #212529;
        white-space: nowrap;
        padding-right: 20px;
    }
    .modal_file_loading {
        font-style: normal;
        font-weight: 400;
        font-size: 14px;
        line-height: 21px;
        color: #212529;
        white-space: nowrap;
    }
    .modal_file_link {
        font-style: normal;
        font-weight: 400;
        font-size: 12px;
        line-height: 18px;
        color: #356EEF;
        display: flex;
        align-items: center;
        gap: 10px;
    }

    .underline {
        width: 100%;
        height: 1px;
        border: 0.5px solid #C8E4FF;
    }

    .product_main_img {
        height: fit-content;
        max-width: 200px;
        max-height: 200px;
    }
    #close_modal {
        cursor: pointer;
    }

    .product-item.active {
        background-color: #C8E4FF;
    }
    .product_img.active {
        border: 1px solid #C8E4FF;
    }
    .product_media_modal_img.active {
        border: 1px solid #C8E4FF;
    }
    .product_video_iframe {
        pointer-events: none;
    }

    .product_media_modal_main_img {
        width: auto;
        height: auto;
        max-height: 465px;
        max-width: 100%;
    }
    .product_media_modal_main_img_container {
        position: relative;
        display: flex;
        align-items: center;
        justify-content: center;
    }
    .product_media_modal_main_img_container .group_btns {
        display: flex;
        gap: 30px;
        position: absolute;
        bottom: 20px;
        right: 20px;
    }
    .modal_content {
        max-height: 100%!important;
    }
    .toggle {
        width: 100%;
    }
    .toggle .title {
        font-style: normal;
        font-weight: 400;
        font-size: 12px;
        line-height: 18px;
        color: #919299;
    }
    .toggle_header {
        display: flex;
        align-items: center;
        height: 40px;
        justify-content: space-between;
        padding: 0 15px 0 15px;
        background: #C8E4FF;
        border: 1px solid #C8E4FF;
        border-radius: 4px;
        cursor: pointer;
    }
    .toggle_header.active {
        border-bottom-right-radius: 0;
        border-bottom-left-radius: 0;
    }
    .form_label {
        font-style: normal;
        font-weight: 500;
        font-size: 14px;
        line-height: 21px;
        color: #000000;
    }
    .toggle_header .form_label {
        line-height: 16px;
    }
    .item_table {
        border-collapse: collapse;
        width: 100%;
    }

    .item_table td, .item_table th {
        border: 1px solid #ddd;
        padding: 8px;
    }

    .item_table th a {
        color: #495057;
    }
    .item_table th a:hover {
        color: #2196F3;
    }
    .item_table tr {
        line-height: 13px;
    }

    .item_table tr:hover {background-color: #eef7ff;}

    .item_table tr.table_head {
        background-color: #f8f9fa;
    }
    .item_table tr.table_head th {
        font-weight: 700;
    }
    .item_table tr th {
        font-weight: normal;
    }
    .item_table th {
        text-align: left;
        color: #495057;
        font-size: 0.8rem;
    }
    .path_item {
        color: #212529;
    }
    .file_link {
        color: #212529;
        word-break: break-all;
    }
    .path_item:hover {
        color: #2196F3;
    }
    .file_link:hover {
        color: #2196F3;
    }
    .product_title {
        padding-top: 10px;
        margin: 0px;
        font-size: 14px;
    }
    .toggle__checkbox:checked + .toggle__switch {
        background: #0D6EFD;
    }
    .toggle__checkbox:checked + .toggle__switch:before {
        left: 11px;
    }
    .toggle__checkbox {
        position: absolute;
        visibility: hidden;
    }
    .toggle__switch {
        display: inline-block;
        background: #FFFFFF;
        border: 1.25px solid rgba(0, 0, 0, 0.15);
        border-radius: 20px;
        width: 20px;
        height: 10px;
        position: relative;
        vertical-align: middle;
        transition: background 0.25s;
        margin-right: 8px;
    }
    .toggle__switch:before, .toggle__switch:after {
        content: '';
    }
    .toggle__switch:before {
        display: block;
        background: linear-gradient(to bottom, #fff 0%, #eee 100%);
        border-radius: 50%;
        box-shadow: 0 0 0 1px rgb(0 0 0 / 25%);
        width: 8px;
        height: 8px;
        position: absolute;
        transition: left 0.25s;
    }
    .toggle:hover .toggle__switch:before {
        background: linear-gradient(to bottom, #fff 0%, #fff 100%);
        box-shadow: 0 0 0 1px rgba(0, 0, 0, 0.5);
    }
    .toggle__checkbox:checked + .toggle__switch {
        background: #0D6EFD;
    }
    .toggle__checkbox:checked + .toggle__switch:before {
        left: 11px;
    }
    .toggle .title {
        font-style: normal;
        font-weight: 400;
        font-size: 12px;
        line-height: 18px;
        color: #919299;
    }
    .checkbox_tree_header {
        display: flex;
        align-items: center;
        justify-content: space-between;
        cursor: pointer;
    }
    .files_tab_content .modal_files_contetn_container {
        margin-top: 10px;
        height: auto;
        max-height: initial;
    }
    .files_tab_content .checkbox_tree_header {
        justify-content: left;
    }
    .files_tab_content .checkbox_tree_item {
        margin-top: 12px;
    }
    .files_tab_content .checkbox_tree_body .form_label {
        padding-left: 25px;
    }
    .checkbox_tree_header svg {
        margin: 0.5rem;
    }
    .checkbox_tree_body {
        padding-left: 30px;
    }
    .modal_content_footer_subtitle {
        display: block;
        font-style: normal;
        font-weight: 400;
        font-size: 12px;
        line-height: 18px;
        color: #6C757D;
        margin-top: 4px;
    }
    .modal_content_footer {
        padding: 12px 0px 12px 0px;
        border-top: 1px solid #C8E4FF;
    }
    .modal_content_footer_btn {
        width: 130px;
        height: 30px;
        background: #356EEF;
        border-radius: 4px;
        font-style: normal;
        font-weight: 400;
        font-size: 14px;
        line-height: 18px;
        text-align: center;
        color: #FFFFFF;
        padding: 18px 30px;
        display: flex;
        align-items: center;
        justify-content: center;
        margin-top: 16px;
    }
    .modal_content_footer_btn.disabled {
        background: #CED4DA;
    }
    .files_tab_content {
        padding: 0 20px;
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        height: 100%;
    }
    .files_modal .form_label {
        font-style: normal;
        font-weight: 400;
        font-size: 14px;
        line-height: 21px;
        display: flex;
        align-items: center;
        color: #212529;
        gap: 11px;
        padding: 2px;
    }
    .form_radio {
        width: 18px;
        height: 18px;
        min-width: 18px;
        padding: 0;
        margin: 0;
        cursor: pointer;
        accent-color: #2196F3;
    }
    input[type='checkbox'] {
        outline-width: 0px;
        outline-style: none;
    }
    input[type='checkbox']:checked {
        outline-width: 0px;
        outline-style: none;
        box-shadow: none;
    }
    input[type='checkbox']:focus {
        box-shadow: none;
    }
    input[type='checkbox']:not(:checked) {
        outline-width: 0px;
        outline-style: none;
        box-shadow: none;
    }
    .p_prices {
        display: flex;
        flex-direction: column;
        justify-content: felx-end;
        text-align: end;
    }
    .text_secondary {
        color: #6C757D;
        font-size: 10px;
    }
    .tab_content .text_secondary {
        padding: 10px .25rem;
    }
    svg.expanded {
        transform: rotate(180deg);
    }
    .modal_files_contetn_container {
        max-height: 40vh;
        height: 40vh;
        overflow: auto;
        margin-top: 20px;
    }
    .input_row {
        display: flex;
        align-items: center;
        gap: 10px;
        padding: 1rem 0px;
        margin-bottom: 17px;
        border-bottom: 1px solid #C8E4FF;
        cursor: pointer;
    }
    .input_row span {
        color: #000;
        font-size: 16px;
        font-style: normal;
        font-weight: 500;
        line-height: 24px;
    }
    input[type="checkbox"] {
        width: 18px;
        height: 18px;
        cursor: pointer;
    }
    .product_list_img {
        max-height: 45px;
        max-width: 45px;
    }

    .product_list_container.loading_back {
        height: 30vh;
        background-color: #dedede;
    }

    .product_list_item {
        padding: 12px;
        border-bottom: 1px solid #C8E4FF;
    }
    .mobile_image_container {
        display: flex;
        min-width: 70px;
        align-items: center;
        justify-content: center;
    }
    .product_list_item_image {
        height: 100%;
        max-height: 70px;
        width: auto;
    }
    .product_list_item_top {
        display: flex;
        gap: 20px;
        width: 100%;
    }
    .item_right_content {
        width: 100%;
    }
    .product_list_item_name {
        font-size: 12px;
        font-weight: 400;
        line-height: 14.4px;
        text-align: left;
        margin-bottom: 8px;
    }
    .product_list_item_sku {
        font-size: 11px;
        font-weight: 400;
        line-height: 21px;
        text-align: left;
        margin-bottom: 0px;
        color: #212529a1;
    }
    .product_list_item_quantity {
        font-size: 12px;
        font-weight: 400;
        line-height: 14.4px;
        text-align: left;
        color: #356EEF;
        margin-bottom: 0px;
    }
    .item_additional_info {
        display: flex;
        align-items: center;
        justify-content: space-between;
        margin-bottom: 8px;
    }
    .product_list_item_bottom {
        display: flex;
        justify-content: space-between;
    }
    .product_list_item_price {
        font-size: 12px;
        font-weight: 500;
        line-height: 18px;
        text-align: left;
        margin-bottom: 0px;
        display: flex;
        gap: 5px;
    }
    .product_list_item_detail {
        font-size: 12px;
        font-weight: 500;
        line-height: 21px;
        text-align: center;
        color: #356EEF;
        text-decoration: underline;
        margin-bottom: 0px;
    }

    .product_list_item:hover {
        background-color: #C8E4FF;
    }

    .data-loader {
        display: flex;
        align-items: center;
        justify-content: center;
        height: 100%;
    }

    .lds-ring {
        display: inline-block;
        position: relative;
        width: 40px;
        height: 40px;
    }
    .lds-ring div {
        box-sizing: border-box;
        display: block;
        position: absolute;
        width: 40px;
        height: 40px;
        margin: 8px;
        border: 4px solid #356EEF;
        border-radius: 50%;
        animation: lds-ring 1.2s cubic-bezier(0.5, 0, 0.5, 1) infinite;
        border-color: #356EEF transparent transparent transparent;
    }
    .lds-ring div:nth-child(1) {
        animation-delay: -0.45s;
    }
    .lds-ring div:nth-child(2) {
        animation-delay: -0.3s;
    }
    .lds-ring div:nth-child(3) {
        animation-delay: -0.15s;
    }
    @keyframes lds-ring {
        0% {
            transform: rotate(0deg);
        }
        100% {
            transform: rotate(360deg);
        }
    }

    .modal_btns {
        display: flex;
        justify-content: space-between;
        gap: 30px;
        padding-top: 20px;
    }
    .remove_all_btn {
        height: 48px;
        padding: 12px 30px 12px 30px;
        color: #000;
        display: flex;
        align-items: center;
        justify-content: center;
    }
    .add_btn {
        height: 48px;
        padding: 12px 30px 12px 30px;
        border-radius: 4px;
        background: #356EEF;
        color: #fff;
        display: flex;
        align-items: center;
        justify-content: center;
    }
    .clear_filter {
        display: flex;
        align-items: center;
        gap: 7px;
        color: #356EEF;
        font-size: 14px;
        line-height: 24px;
    }

    .open_filters_popup, .open_search_popup, .open_sorting_popup {
        position: relative;
    }
    .red_dot {
        width: 10px;
        height: 10px;
        position: absolute;
        top: -3px;
        right: -3px;
        border: 2px;
        background-color: #B70D09;
        border-radius: 50%;
    }

    .text-danger {
        color: #dc3545;
    }

    .filters .filters_tab_variant {
        display: flex;
        gap: 5px;
    }
    
    .filter_content_top {
        display: flex;
        justify-content: flex-end;
        padding-top: 10px;
        padding-bottom: 10px;
    }
    
    .filter_content_top .p-button-clear {
        font-size: 14px;
        display: flex;
        align-items: center;
        gap: 5px;
    }

    .promo_tag_item {
        width: auto;
    }

    .list_img_container {
        position: relative;
        width: 45px;
        height: 45px;
        text-align: center;
    }
    .promo_tag_list {
        padding: 0px;
        font-size: 10px;
        position: absolute;
        right: 0px;
        top: 0px;
        z-index: 99;
        display: flex;
        flex-direction: column;
        align-items: flex-end;
        gap: 1px;
    }
    .promo_tag_list_tag {
        width: fit-content;
        height: 10px;
        padding: 2px;
        font-size: 10px;
    }

    .promo_tag_list_mobile {
        width: 30px;
        font-size: 10px;
        margin-left: 3px;
        padding: 0px;
    }

    @media (max-width: 1024px) {
        #price-list-internal {
            flex-direction: column;
        }
        .sidebar_left {
            width: 100%;
        }
    }

    @media (max-width: 760px) {
        .container {
            padding: 50px 0 0 0;
        }
        .catalog_search_input {
            min-width: 100%;
            font-size: 17px;
        }
        .content_header_title {
            font-size: 26px;
            font-weight: 700;
            line-height: 31.2px;
            height: auto;
            min-width: auto;
        }
        .content_header_container {
            display: flex;
            justify-content: space-between;
            align-items: center;
        }
        .mobile_bar {
            display: flex;
            justify-content: space-between;
            padding-top: 40px;
            padding-bottom: 13px;
        }
        .mobile_bar_items {
            display: flex;
            align-items: center;
            gap: 30px;
        }
        .content_result, .filters {
            height: 100%;
        }
        .product_info_container {
            flex-direction: column;
        }
        .block_main_info {
            width: auto;
        }
        .tabs {
            display: block;
            height: auto;
        }
        .tabs_row {
            display: grid;
            grid-template-columns: 1fr 1fr;
        }
        .tab_item {
            text-align: center;
            font-size: 13px;
        }
        .info_list {
            height: 100%;
            min-height: 30vh;
        }
        .info_list_item_title {
            text-wrap: wrap;
        }
        .block_info .info_list_item_title, .block_info .info_list_item_value {
            font-size: 13px;
        }
        .product_title {
            margin-bottom: 10px;
        }
        .toggle_header svg {
            min-width: 30px;
        }
        .toggle_header .form_label {
            overflow: auto;
            white-space: nowrap;
        }
        .product_main_img {
            height: auto;
            max-height: 200px;
            width: auto;
            max-width: 100%!important;
        }
        .categories_modal {
            height: 100vh;
        }
        .catalog_list_item {
            display: flex;
            align-items: center;
            justify-content: space-between;
            min-height: 35px;
        }
        .catalog_list_item_back {
            display: flex;
            align-items: center;
            min-height: 35px;
        }
        .catalog_list_item:hover {
            background-color: #C8E4FF;
        }
        .catalog_list_item_back:focus, .catalog_list_item_back:active {
            background-color: #C8E4FF;
        }
        .catalog_list_item.active {
            background-color: #C8E4FF;
        }
        .catalog_list_item p, .catalog_list_item_back p {
            margin: 0px;
            padding-left: 5px;
            font-size: 14px;
            line-height: 21px;
            font-weight: 400;
        }
        .catalog_list_item_btn {
            width: 25px;
            min-width: 25px;
            height: 35px;
            display: flex;
            align-items: center;
            justify-content: center;
        }
        .modal_content .tab {
            padding: 8px 12px 8px 12px;
            border-radius: 4px;
            border: 1px solid #CED4DA;
        }
        .modal_content .tab_head {
            padding: 0px .25rem;
        }
        .modal_content .tab_head.active {
            border-bottom: 1px solid #D9D9D9;
            padding-bottom: 18px;
        }
        .modal_content .tab_container {
            display: flex;
            flex-direction: column;
            gap: 16px;
            padding-top: 16px;
        }
        .product_info_text {
            font-size: 13px;
        }
    }
</style>
